import React from 'react'

const Icon = ({ children }: { children: React.ReactNode }): JSX.Element => (
    <span className="inline-block">{children}</span>
)

export const Bang = ({ className = '' }: { className?: string }): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 189 139">
        <path
            d="M162.525 126.754L121.278 111.361L111.429 138.448L92.9646 113.213L72.0271 135.989L68.9485 110.748L30.1657 135.369L44.9387 95.9742L19.0835 102.744L36.3224 82.4267L-0.00151825 68.8865L44.937 62.7293L14.1584 25.7854L62.7956 40.5658V0.55072L88.6508 33.7958L97.2666 7.3207L105.27 40.5658L148.983 6.70078L134.823 42.4123L164.989 33.7966L147.138 62.7306L188.998 79.9695L138.514 89.198L162.525 126.754Z"
            fill="#F1A82C"
        />
    </svg>
)

export const Check3 = ({ className = '' }: { className?: string }): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="currentColor" width="18" height="18">
        <g clipPath="url(#a)">
            <path
                fillRule="evenodd"
                d="M15.919 2.752c.24.197.276.551.079.792L6.652 14.967a.562.562 0 0 1-.833.041l-4.154-4.153a.563.563 0 0 1 .795-.796l3.715 3.714 8.952-10.942a.563.563 0 0 1 .792-.079Z"
                clipRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path d="M1.5 2.25h15v13.5h-15z" />
            </clipPath>
        </defs>
    </svg>
)

export const Eco = ({ className = '' }: { className?: string }): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 17 16">
        <path
            fill="#fff"
            d="M10.495 14.222c-.172.057-.401.057-.573.115.172-.058.4-.115.573-.115ZM15.258 9.749c-.057.229-.115.401-.172.573.057-.172.115-.4.172-.573ZM15.024 10.38l-.344.688a3.91 3.91 0 0 0 .344-.688ZM15.42 9.004c0 .172-.057.344-.115.516.058-.172.058-.344.115-.516ZM15.315 9.52c0 .057-.057.115-.057.172 0-.059 0-.115.057-.172ZM15.424 8.774c0 .057 0 .115-.057.23.057-.115.057-.172.057-.23Z"
        />
        <path fill="#fff" d="M15.026 10.322c0 .057 0 .057-.057.115.057-.057.057-.115.057-.115Z" />
        <path
            fill="#fff"
            d="M13.993 12.1c-1.836-2.18-4.416-4.588-6.25-6.25a.52.52 0 0 1-.173-.4c0-.345.23-.574.574-.574.115 0 .287.057.4.115h.058c2.58 2.352 4.644 4.358 6.136 6.078l.344-.688s0-.057.057-.115c.057-.172.115-.401.172-.573 0-.057.057-.115.057-.172.057-.172.057-.344.115-.516 0-.057 0-.115.057-.23-.057-.23-.057-.518-.057-.747 0-4.472-4.702-6.824-9.175-6.88C2.236 1.09 0 0 0 0s.573 5.85 1.777 9.118c1.378 3.727 3.9 5.219 7.399 5.219.229 0 .459 0 .688-.057h.057c.172 0 .4-.057.573-.115h.057c.4-.115.803-.23 1.204-.401a9.33 9.33 0 0 0 1.032-.573C13.934 14.51 14.68 15.541 14.68 16h1.72c-.057-.861-1.031-2.351-2.407-3.9Z"
        />
    </svg>
)

export const RightArrow = ({ className }: { className: string }): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
    </svg>
)

export const Plus = (props: any): JSX.Element => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" {...props}>
            <path
                fillRule="evenodd"
                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                clipRule="evenodd"
            />
        </svg>
    )
}

export const Minus = ({ className = '', ...other }): JSX.Element => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-5 w-5 ${className}`}
            viewBox="0 0 20 20"
            fill="currentColor"
            {...other}
        >
            <path fillRule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" clipRule="evenodd" />
        </svg>
    )
}

export const Chevron = ({ className = '' }: { className?: string }): JSX.Element => {
    return (
        <svg className={className} viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.15448 0.316976L5.00049 3.47201L1.8465 0.316976C1.42387 -0.105659 0.73923 -0.105659 0.316596 0.316976C-0.105532 0.739104 -0.105532 1.42425 0.316596 1.84636L4.23586 5.76563C4.65799 6.18726 5.34211 6.18726 5.76421 5.76563L9.68296 1.84688V1.84637C10.1056 1.42425 10.1056 0.740128 9.68347 0.317507C9.26134 -0.105115 8.57722 -0.105128 8.1546 0.317L8.15448 0.316976Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const CircleArrow = ({ className }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle r="16" transform="matrix(-1 0 0 1 16 16)" fill="#BFBFBC" />
            <path
                d="M22.6355 15.4335L17.5539 10.3511C17.0857 9.88295 16.3052 9.88295 15.837 10.3511C15.3688 10.8193 15.3688 11.5999 15.837 12.068L18.8372 15.0865H10.2142C9.53798 15.0865 9 15.6244 9 16.3006C9 16.9768 9.53798 17.5148 10.2142 17.5148H18.8372L15.8363 20.5157C15.3681 20.9839 15.3681 21.7644 15.8363 22.2326C16.0789 22.4751 16.3912 22.5971 16.7036 22.5971C17.0159 22.5971 17.3283 22.4758 17.5708 22.2326L22.6355 17.1679C22.8611 16.9423 23 16.63 23 16.3007C23 15.9714 22.8788 15.6591 22.6355 15.4335Z"
                fill="white"
            />
        </svg>
    )
}

export const Edit = ({ className = '' }: { className?: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m16.493 2.902-1.395-1.395a1.725 1.725 0 0 0-2.442 0l-9.62 9.62a4.001 4.001 0 0 0-.973 1.579l-1.011 3.03a.959.959 0 0 0 1.216 1.212l3.03-1.011a4.043 4.043 0 0 0 1.576-.973l.332-.34.677-.679 7.19-7.188.678-.68.742-.74c.67-.674.67-1.762 0-2.435ZM6.194 14.285c-.336.336-.747.59-1.199.743l-3.036 1.01 1.012-3.033a3.1 3.1 0 0 1 .74-1.201l.332-.33 2.483 2.479-.332.332Zm1.01-1.004-2.48-2.495 7.19-7.18 2.48 2.48-7.19 7.195Zm8.61-8.616-.743.749-2.479-2.495.741-.743a.766.766 0 0 1 1.086 0l1.395 1.395a.77.77 0 0 1 0 1.087v.007Z" />
        </svg>
    )
}

export const Issue = ({ className = '' }: { className?: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M9 13.806a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM8.91 5.886a1.01 1.01 0 0 0-.919 1.098l.342 3.69a.69.69 0 0 0 .612.612.671.671 0 0 0 .738-.612l.342-3.69v-.18c-.072-.558-.558-.972-1.116-.918Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.833 2.76c.962-1.67 3.371-1.67 4.333 0l6.04 10.493c.96 1.666-.243 3.747-2.166 3.747H2.96C1.036 17-.167 14.92.792 13.253L6.832 2.76Zm3.466.5a1.5 1.5 0 0 0-2.6 0L1.66 13.752A1.5 1.5 0 0 0 2.959 16H15.04a1.5 1.5 0 0 0 1.3-2.248L10.3 3.26Z"
            />
        </svg>
    )
}

export const MobileMenu = ({ className, style }: { className: string; style: any }): JSX.Element => {
    return (
        <svg
            className={className}
            style={style}
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.5">
                <path
                    d="M8.99992 0C9.70943 0 10.2878 0.578406 10.2878 1.28792C10.2878 1.99743 9.70943 2.57583 8.99992 2.57583H1.28784C0.578331 2.57583 -7.62939e-05 1.99743 -7.62939e-05 1.28792C-7.62939e-05 0.578406 0.578331 0 1.28784 0H8.99992Z"
                    fill="currentColor"
                />
                <path
                    d="M17.7841 7.00257C17.8072 7.03342 17.8149 7.07969 17.8303 7.11825C17.8689 7.18766 17.8997 7.26478 17.9229 7.3419C17.9383 7.38817 17.9614 7.42673 17.9769 7.473C17.9846 7.51928 17.9769 7.55784 17.9769 7.60411C17.9769 7.64267 18 7.68123 18 7.71979C18 7.75835 17.9769 7.79691 17.9769 7.83547C17.9692 7.88175 17.9846 7.92031 17.9769 7.96658C17.9692 8.01285 17.9383 8.05141 17.9229 8.09768C17.8997 8.1748 17.8689 8.25192 17.8303 8.32133C17.8072 8.35989 17.8072 8.39845 17.7841 8.43701L15.2159 12.2931C14.9691 12.6632 14.5604 12.8637 14.144 12.8637C13.8972 12.8637 13.6504 12.7943 13.4344 12.6478C12.8406 12.2545 12.6864 11.4524 13.0797 10.8663L14.3213 9.00771H1.28792C0.578405 9.00771 0 8.4293 0 7.71979C0 7.01028 0.578405 6.43187 1.28792 6.43187H14.3136L13.072 4.57326C12.6787 3.97943 12.8406 3.18509 13.4267 2.79177C14.0206 2.39846 14.8149 2.56041 15.2082 3.14653L17.7841 7.00257Z"
                    fill="currentColor"
                />
                <path
                    d="M1.28784 12.856H8.99992C9.70943 12.856 10.2878 13.4344 10.2878 14.1439C10.2878 14.8535 9.70943 15.4242 8.99992 15.4242H1.28784C0.578331 15.4242 -7.62939e-05 14.8457 -7.62939e-05 14.1362C-7.62939e-05 13.4267 0.578331 12.856 1.28784 12.856Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}

export const SliderNavArrow = ({
    className,
    style,
    bgColor,
    arrowColor,
}: {
    bgColor: string
    arrowColor: string
    className: string
    style: any
}): JSX.Element => {
    return (
        <svg
            className={className}
            style={style}
            width="42"
            height="34"
            viewBox="0 0 42 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="42" height="34" rx="6" fill={bgColor} />
            <path
                d="M29.1709 16.0995L23.8975 10.8253C23.4116 10.3395 22.6016 10.3395 22.1158 10.8253C21.6299 11.3112 21.6299 12.1212 22.1158 12.607L25.2292 15.7394H13.7092C13.0075 15.7394 12.4492 16.2977 12.4492 16.9994C12.4492 17.7011 13.0075 18.2594 13.7092 18.2594H25.2292L22.115 21.3736C21.6292 21.8594 21.6292 22.6694 22.115 23.1553C22.3668 23.407 22.6909 23.5336 23.015 23.5336C23.3392 23.5336 23.6633 23.4077 23.915 23.1553L29.1709 17.8995C29.405 17.6653 29.5491 17.3412 29.5491 16.9995C29.5491 16.6578 29.4233 16.3336 29.1709 16.0995L29.1709 16.0995Z"
                fill={arrowColor}
            />
        </svg>
    )
}

export const LinkedIn = ({ className }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                d="M19.893 19.717h-3.111v-4.825c0-1.15-.021-2.632-1.619-2.632-1.62 0-1.868 1.254-1.868 2.548v4.908h-3.112V9.794h2.987v1.356h.042a3.26 3.26 0 0 1 1.25-1.204 3.3 3.3 0 0 1 1.697-.398c3.154 0 3.735 2.054 3.735 4.726l-.001 5.443ZM6.673 8.438c-.358 0-.707-.104-1.004-.3a1.792 1.792 0 0 1-.665-.803 1.772 1.772 0 0 1 .39-1.949 1.822 1.822 0 0 1 1.968-.388c.33.136.613.365.811.659a1.775 1.775 0 0 1-.224 2.257 1.807 1.807 0 0 1-1.277.524Zm1.555 11.279H5.113V9.794h3.115v9.923ZM21.444 2H3.55a1.54 1.54 0 0 0-1.088.432A1.51 1.51 0 0 0 2 3.5v17.792c.005.402.17.786.461 1.068.29.281.682.437 1.089.432h17.894c.407.005.8-.15 1.092-.431.291-.281.458-.666.464-1.069V3.499a1.513 1.513 0 0 0-.465-1.068 1.544 1.544 0 0 0-1.09-.43"
            />
        </svg>
    )
}

export const TrendUp = ({ className }: { className: string }): JSX.Element => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="currentColor">
        <path
            fillRule="evenodd"
            d="m16.771 8.519-3.936 3.935L8.252 7.87l-7.065 7.065 1.296 1.296 5.77-5.768 4.582 4.583 5.232-5.231 2.102 2.102v-5.5h-5.5l2.102 2.102Z"
            clipRule="evenodd"
        />
    </svg>
)

export const Twitter = ({ className }: { className: string }): JSX.Element => {
    return (
        <svg className={className} height="23" viewBox="0 0 1200 1227" width="23" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const GitHub = ({ className = '' }: { className?: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.9906 1.78809C6.19453 1.78574 1.5 6.47793 1.5 12.2693C1.5 16.849 4.43672 20.742 8.52656 22.1717C9.07734 22.31 8.99297 21.9186 8.99297 21.6514V19.835C5.8125 20.2076 5.68359 18.1029 5.47031 17.7514C5.03906 17.0154 4.01953 16.8279 4.32422 16.4764C5.04844 16.1037 5.78672 16.5701 6.64219 17.8334C7.26094 18.7498 8.46797 18.5951 9.07969 18.4428C9.21328 17.892 9.49922 17.3998 9.89297 17.0178C6.59766 16.4271 5.22422 14.4162 5.22422 12.0256C5.22422 10.8654 5.60625 9.79902 6.35625 8.93887C5.87812 7.5209 6.40078 6.30684 6.47109 6.12637C7.83281 6.00449 9.24844 7.10137 9.35859 7.18809C10.132 6.97949 11.0156 6.86934 12.0047 6.86934C12.9984 6.86934 13.8844 6.98418 14.6648 7.19512C14.9297 6.99355 16.2422 6.05137 17.5078 6.16621C17.5758 6.34668 18.0867 7.53262 17.6367 8.93184C18.3961 9.79434 18.7828 10.8701 18.7828 12.0326C18.7828 14.4279 17.4 16.4412 14.0953 17.0225C14.3784 17.3008 14.6031 17.6328 14.7564 17.999C14.9098 18.3652 14.9886 18.7583 14.9883 19.1553V21.792C15.007 22.0029 14.9883 22.2115 15.3398 22.2115C19.4906 20.8123 22.4789 16.8912 22.4789 12.2717C22.4789 6.47793 17.782 1.78809 11.9906 1.78809V1.78809Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const ExternalLink = ({ className }: { className: string }): JSX.Element => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-5 w-5 ${className} opacity-50 group-hover:opacity-75`}
            viewBox="0 0 20 20"
            fill="currentColor"
        >
            <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
            <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
        </svg>
    )
}

export const SessionRecordings = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.5"
                d="M0.8125 8.07634V0.855964C0.8125 0.571684 1.0436 0.340576 1.32789 0.340576H8.54826C8.83254 0.340576 9.06365 0.571681 9.06365 0.855964C9.06365 1.14025 8.83255 1.37135 8.54826 1.37135H1.84327V8.07535C1.84327 8.35963 1.61217 8.59074 1.32789 8.59074C1.04361 8.5917 0.8125 8.36062 0.8125 8.07634ZM22.988 0.340576H15.7676C15.4834 0.340576 15.2523 0.571681 15.2523 0.855964C15.2523 1.14025 15.4834 1.37135 15.7676 1.37135H22.4716V8.07535C22.4716 8.35963 22.7027 8.59074 22.987 8.59074C23.2713 8.59074 23.5024 8.35963 23.5024 8.07535L23.5034 0.855964C23.5034 0.571684 23.2723 0.340576 22.988 0.340576ZM22.988 14.7803C22.7037 14.7803 22.4726 15.0114 22.4726 15.2957V21.9997L15.7676 22.0007C15.4834 22.0007 15.2523 22.2318 15.2523 22.5161C15.2523 22.8004 15.4834 23.0315 15.7676 23.0315H22.988C23.2723 23.0315 23.5034 22.8004 23.5034 22.5161V15.2957C23.5034 15.0114 23.2723 14.7803 22.988 14.7803ZM8.54826 22.0007H1.84327V15.2957C1.84327 15.0114 1.61217 14.7803 1.32789 14.7803C1.0436 14.7803 0.8125 15.0114 0.8125 15.2957V22.5161C0.8125 22.8004 1.0436 23.0315 1.32789 23.0315H8.54826C8.83254 23.0315 9.06365 22.8004 9.06365 22.5161C9.06365 22.2318 8.83255 22.0007 8.54826 22.0007Z"
                fill="currentColor"
            />
            <path
                d="M16.7994 11.6861C16.7994 9.12752 14.7165 7.04468 12.1579 7.04468C9.59935 7.04468 7.51649 9.12754 7.51649 11.6861C7.51649 14.2447 9.59935 16.3276 12.1579 16.3276C14.7165 16.3276 16.7994 14.2447 16.7994 11.6861Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const FeatureFlags = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="22"
            height="21"
            viewBox="0 0 22 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.73769 9.39277H17.2628C19.7588 9.39277 21.7779 7.35059 21.7779 4.87774C21.7779 2.38174 19.7357 0.362703 17.2628 0.362703L4.73769 0.361816C2.24169 0.361816 0.222656 2.404 0.222656 4.87685C0.222656 7.35061 2.26484 9.39279 4.73769 9.39279V9.39277ZM17.2638 2.33545C18.6704 2.33545 19.8049 3.49305 19.8049 4.8766C19.8049 6.26111 18.6473 7.41776 17.2638 7.41776C15.8571 7.41776 14.7226 6.26016 14.7226 4.8766C14.7217 3.49298 15.8563 2.33545 17.2638 2.33545Z"
                fill="currentColor"
            />
            <path
                opacity="0.5"
                d="M17.2638 11.6619H4.73769C2.24169 11.6619 0.222656 13.704 0.222656 16.1769C0.222656 18.6729 2.26484 20.6919 4.73769 20.6919H17.2628C19.7588 20.6919 21.7779 18.6497 21.7779 16.1769C21.7788 13.704 19.7366 11.6619 17.2635 11.6619H17.2638ZM4.73769 18.7192C3.33104 18.7192 2.19654 17.5616 2.19654 16.178C2.19654 14.7714 3.35414 13.6369 4.73769 13.6369C6.14435 13.6369 7.27885 14.7945 7.27885 16.178C7.27973 17.5847 6.14519 18.7192 4.73769 18.7192Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const PathAnalysis = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="28"
            height="22"
            viewBox="0 0 28 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.2591 9.98521H20.0711C19.1942 9.9876 18.3496 9.65384 17.7095 9.05327L14.074 5.64492L11.4181 3.15538C10.4778 2.2713 9.23483 1.7796 7.94392 1.78199H5.75586C5.83003 2.04877 5.86712 2.32391 5.86592 2.60028C5.86712 2.87783 5.83003 3.15538 5.75586 3.42216H7.94392C8.81844 3.42096 9.66065 3.75472 10.2971 4.3541L14.0726 7.89414L16.5885 10.2521C17.53 11.1362 18.7718 11.6267 20.0627 11.6267H22.2507C22.1802 11.3575 22.1479 11.0812 22.1538 10.8036C22.1526 10.5272 22.1885 10.2521 22.2591 9.9853L22.2591 9.98521Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M15.363 9.99909L14.1212 8.83984L14.0734 8.93555L12.6426 11.6093L13.8844 12.7734L14.0734 12.4228L15.363 9.99909Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M9.9528 16.6495C9.44916 17.5982 8.46338 18.1903 7.38908 18.1891H5.74414C5.81831 18.4559 5.8554 18.7311 5.85301 19.0074C5.8554 19.285 5.81831 19.5625 5.74414 19.8305H7.38908C8.21335 19.8317 9.02205 19.608 9.72908 19.1845C10.4361 18.7598 11.0139 18.1521 11.4015 17.4235L12.4423 15.4723L11.2041 14.3047L9.9528 16.6495Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M22.2568 1.78198H20.6118C19.7876 1.78198 18.9789 2.00569 18.273 2.4292C17.566 2.85269 16.9882 3.46162 16.5994 4.18779L15.5586 6.13899L16.8016 7.30302L18.0481 4.96183V4.96303C18.5518 4.01433 19.5376 3.42218 20.6119 3.42218H22.2616C22.1874 3.1554 22.1503 2.87787 22.1515 2.60031C22.1503 2.32396 22.1862 2.0488 22.2568 1.78202L22.2568 1.78198Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M22.2577 18.1888H20.0696C19.1951 18.1888 18.3541 17.8551 17.7164 17.2569L14.0726 13.8666L11.4167 11.3771C10.4764 10.4918 9.23344 10.0013 7.94253 10.0037H5.75447C5.82505 10.2645 5.85855 10.5337 5.85496 10.804C5.85735 11.0816 5.82027 11.3591 5.74609 11.6271H7.93416C8.81107 11.6223 9.65686 11.9537 10.2957 12.5542L14.0712 16.0943L16.5871 18.4522C17.5286 19.3351 18.7704 19.8268 20.0613 19.8256H22.2493C22.1752 19.5576 22.1381 19.2813 22.1393 19.0025C22.1429 18.7274 22.1835 18.4546 22.2577 18.189L22.2577 18.1888Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M5.19831 2.60103C5.19831 1.57938 4.60016 0.652216 3.66941 0.231111C2.73866 -0.189994 1.64642 -0.0260966 0.880772 0.649828C0.113932 1.32574 -0.18516 2.38809 0.115126 3.36429C0.416601 4.34048 1.26121 5.0511 2.27569 5.17792V5.19945V8.2058V8.22734C0.981255 8.39602 0.0134486 9.49901 0.0134486 10.8042C0.0134486 12.1094 0.981286 13.2124 2.27569 13.3811V16.3875C0.914277 16.5573 -0.0798683 17.7585 0.00505712 19.1282C0.0911922 20.4968 1.22651 21.5639 2.5987 21.5639C3.97208 21.5639 5.10738 20.4968 5.19353 19.1282C5.27847 17.7584 4.28431 16.5573 2.9229 16.3875V13.4026C4.21733 13.234 5.18514 12.131 5.18514 10.8258C5.18514 9.52057 4.2173 8.41755 2.9229 8.24887V8.22733V5.19945V5.17792C4.22211 5.01522 5.19711 3.90982 5.19831 2.60103Z"
                fill="black"
            />
            <path
                d="M3.66927 0.231111C4.60002 0.652216 5.19817 1.57938 5.19817 2.60103C5.19698 3.90982 4.22198 5.01522 2.92277 5.17792H2.27555C1.26107 5.0511 0.416466 4.34048 0.114991 3.36429C-0.185295 2.38809 0.113797 1.32574 0.880637 0.649828C1.64628 -0.0260966 2.73852 -0.189994 3.66927 0.231111Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M27.9991 10.804C27.9979 9.49401 27.0229 8.3898 25.7237 8.22708V8.20555V5.1992V5.17766C27.0851 5.00659 28.0792 3.80667 27.9943 2.4369C27.9082 1.0671 26.7729 0 25.4007 0C24.0273 0 22.892 1.06713 22.8058 2.4369C22.7209 3.8067 23.7151 5.00659 25.0765 5.17766V5.1992V8.20555V8.22708C23.782 8.39576 22.8142 9.49876 22.8142 10.804C22.8142 12.1092 23.7821 13.2122 25.0765 13.3809V16.3872C23.7151 16.5571 22.7209 17.7582 22.8058 19.128C22.892 20.4966 24.0273 21.5637 25.4007 21.5637C26.7729 21.5637 27.9082 20.4966 27.9943 19.128C28.0793 17.7582 27.0851 16.5571 25.7237 16.3872V13.4024C27.0313 13.2385 28.0086 12.1223 27.9991 10.804Z"
                fill="black"
            />
            <path
                d="M25.7239 8.2271C27.0231 8.38982 27.9981 9.49403 27.9993 10.804C28.0089 12.1223 27.0315 13.2385 25.7239 13.4024L25.0767 13.3809C23.7823 13.2122 22.8145 12.1092 22.8145 10.804C22.8145 9.49878 23.7823 8.39578 25.0767 8.2271H25.7239Z"
                fill="black"
            />
        </svg>
    )
}

export const Cohorts = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="28"
            height="30"
            viewBox="0 0 28 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.5"
                d="M0.813147 12.1683C2.7164 6.5674 8.03584 3.09748 13.6563 3.2827L13.2304 16.3914L25.5586 11.9309C26.5387 14.6343 26.6474 17.6764 25.6494 20.6112C23.3185 27.4703 15.8692 31.1378 9.01014 28.807C2.15104 26.4743 -1.51825 19.0254 0.812519 12.1677L0.813147 12.1683Z"
                fill="black"
            />
            <path
                d="M15.318 0.898193C16.5796 0.939181 17.8556 1.16016 19.1137 1.58784C23.0361 2.92262 25.909 5.9325 27.2188 9.54641L14.8906 14.0051L15.318 0.898193Z"
                fill="black"
            />
        </svg>
    )
}

export const Funnels = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.93866 20.2033C5.93866 21.6777 4.74362 22.8728 3.26913 22.8728C1.79465 22.8728 0.599609 21.6777 0.599609 20.2033V2.8514C0.599609 1.37692 1.79465 0.181885 3.26913 0.181885C4.74362 0.181885 5.93866 1.37692 5.93866 2.8514V20.2033Z"
                fill="currentColor"
            />
            <path
                opacity="0.75"
                d="M14.2785 20.2033C14.2785 21.6778 13.0835 22.8728 11.609 22.8728C10.1345 22.8728 8.93945 21.6778 8.93945 20.2033V9.52523C8.93945 8.05075 10.1345 6.85571 11.609 6.85571C13.0835 6.85571 14.2785 8.05075 14.2785 9.52523V20.2033Z"
                fill="currentColor"
            />
            <path
                opacity="0.5"
                d="M22.6164 20.2032C22.6164 21.6777 21.4213 22.8727 19.9469 22.8727C18.4724 22.8727 17.2773 21.6777 17.2773 20.2032V13.5294C17.2773 12.0549 18.4724 10.8599 19.9469 10.8599C21.4213 10.8599 22.6164 12.0549 22.6164 13.5294V20.2032Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const ServerLocked = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.75"
                d="M28.928 10.2852H31.1428C31.3636 9.9069 31.5 9.47098 31.5 8.99988V2.57208C31.5 1.15177 30.3483 6.10352e-05 28.928 6.10352e-05H3.2146C1.79289 6.10352e-05 0.642578 1.15177 0.642578 2.57208V8.99988C0.642578 9.47098 0.777578 9.9069 0.998359 10.2852H28.928ZM9.64276 5.14259H10.9281V6.4279H9.64276V5.14259ZM7.07214 5.14259H8.35745V6.4279H7.07214V5.14259ZM4.50013 5.14259H5.78543V6.4279H4.50013V5.14259Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M17.357 20.5722H19.929C19.929 16.6727 23.1015 13.5 27.0012 13.5C28.7084 13.5 30.2792 14.1089 31.5012 15.1214L31.4998 12.8573C31.4998 12.3862 31.3634 11.9503 31.144 11.572H0.998359C0.777578 11.9503 0.642578 12.3862 0.642578 12.8573V19.2851C0.642578 19.7562 0.777578 20.1921 0.998359 20.5704L3.21459 20.5718L17.357 20.5722ZM9.64221 15.4282H10.9275V16.7135L9.64221 16.7149V15.4282ZM7.07159 15.4282H8.3569V16.7135L7.07159 16.7149V15.4282ZM4.49957 15.4282H5.78488V16.7135L4.49957 16.7149V15.4282Z"
                fill="black"
            />
            <path
                opacity="0.25"
                d="M3.21459 21.8574H0.998359C0.777578 22.2371 0.642578 22.673 0.642578 23.1427V29.5705C0.642578 30.9894 1.79289 32.1426 3.2146 32.1426H17.3572V21.8574L3.21459 21.8574ZM5.78521 27H4.4999V25.7147H5.78521V27ZM8.35723 27H7.07192V25.7147H8.35723V27ZM9.64253 27V25.7147H10.9278V27H9.64253Z"
                fill="black"
            />
            <path
                d="M32.785 20.5722C32.785 17.3772 30.1947 14.787 26.9998 14.787C23.8049 14.787 21.2146 17.3774 21.2146 20.5722V21.8576H18.6426V36.0002H35.3574V21.8576H32.7854L32.785 20.5722ZM26.3572 32.143V29.4528C25.6105 29.1871 25.0719 28.4811 25.0719 27.643C25.0719 26.5785 25.9353 25.715 26.9999 25.715C28.0644 25.715 28.9279 26.5785 28.9279 27.643C28.9279 28.4811 28.3893 29.1871 27.6425 29.4528V32.143H26.3572ZM31.4998 21.8578H22.4998V20.5725C22.4998 18.0905 24.5178 16.0725 26.9998 16.0725C29.4818 16.0725 31.4998 18.0905 31.4998 20.5725V21.8578Z"
                fill="black"
            />
        </svg>
    )
}

export const WebCode = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 24.5988C0 26.3987 1.44056 27.8393 3.24047 27.8393H32.7593C34.5592 27.8393 35.9998 26.3987 35.9998 24.5988V7.79968H7.99137e-05L0 24.5988ZM21.958 19.3599L24.5985 16.7194L22.1987 14.3195C21.9581 14.0789 21.9581 13.6399 22.1987 13.3992C22.4393 13.1586 22.8783 13.1586 23.1189 13.3992L25.9188 16.1991C26.1985 16.4788 26.1985 16.9584 25.9188 17.2397L22.8783 20.2801C22.6377 20.5208 22.1987 20.5208 21.958 20.2801C21.719 20.0395 21.719 19.5989 21.958 19.3599ZM15.4396 19.8786L19.5986 13.079C19.7986 12.7587 20.1985 12.679 20.4782 12.879C20.7985 13.079 20.8782 13.4789 20.6782 13.7586L16.5192 20.5583C16.3192 20.8785 15.9192 20.9582 15.6396 20.7582C15.3583 20.5598 15.2396 20.1989 15.4396 19.8786ZM9.87908 16.16L12.6789 13.3602C12.9195 13.1196 13.3586 13.1196 13.5992 13.3602C13.8398 13.6008 13.8398 14.0398 13.5992 14.2805L11.1993 16.6803L13.8398 19.3208C14.0804 19.5614 14.0804 20.0005 13.8398 20.2411C13.5992 20.4817 13.1602 20.4817 12.9196 20.2411L9.87908 17.2006C9.55878 16.96 9.55878 16.4788 9.87908 16.16Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M35.9982 3.24053C35.9982 1.44063 34.5576 6.10352e-05 32.7577 6.10352e-05H3.24047C1.44056 6.10352e-05 0 1.44063 0 3.24053V6.92002H35.9981L35.9982 3.24053ZM4.07946 4.76077C3.63885 4.76077 3.32014 4.40141 3.32014 4.00145C3.32014 3.56083 3.6795 3.24213 4.07946 3.24213C4.52008 3.24213 4.83878 3.60149 4.83878 4.00145C4.84035 4.44051 4.52005 4.76077 4.07946 4.76077ZM6.55901 4.76077C6.1184 4.76077 5.79969 4.40141 5.79969 4.00145C5.79969 3.56083 6.15905 3.24213 6.55901 3.24213C6.99963 3.24213 7.31833 3.60149 7.31833 4.00145C7.3199 4.44051 6.95898 4.76077 6.55901 4.76077ZM9.24011 4.76077C8.79949 4.76077 8.48079 4.40141 8.48079 4.00145C8.48079 3.56083 8.84015 3.24213 9.24011 3.24213C9.64007 3.24213 9.99943 3.60149 9.99943 4.00145C9.99943 4.44051 9.64007 4.76077 9.24011 4.76077ZM31.9981 4.47954C31.9981 4.63891 31.8778 4.75921 31.7184 4.75921L17.9988 4.76077C17.8394 4.76077 17.7191 4.64047 17.7191 4.4811V3.52179C17.7191 3.36242 17.8394 3.24212 17.9988 3.24212H31.7184C31.8778 3.24212 31.9981 3.36242 31.9981 3.52179V4.47954Z"
                fill="black"
            />
        </svg>
    )
}

export const Prohibited = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="37"
            height="37"
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.0095 36.8909C23.6043 36.8891 28.8811 34.284 32.2864 29.8417C35.6898 25.401 36.8368 19.6297 35.386 14.2254C33.9351 8.82113 30.0535 4.39812 24.883 2.25888C19.7126 0.11945 13.8407 0.505968 8.99519 3.30521C4.15013 6.10446 0.883272 10.9983 0.153315 16.5466C-0.574801 22.0931 1.31651 27.6663 5.2736 31.6217C8.64995 35.0035 13.2327 36.9003 18.0097 36.8911L18.0095 36.8909ZM28.135 29.0165C25.6522 31.4921 22.3478 32.9718 18.8471 33.1767C15.3467 33.3835 11.8914 32.2994 9.13492 30.1311L29.2529 10.0187V10.0169C31.4211 12.773 32.5035 16.2284 32.2985 19.7291C32.0918 23.2295 30.6103 26.5339 28.1347 29.0169L28.135 29.0165ZM7.88396 8.76544C10.3272 6.32754 13.5671 4.85331 17.0098 4.61062C20.4509 4.36971 23.8652 5.37652 26.6249 7.44945L6.5681 27.5026C4.49698 24.7429 3.49197 21.3288 3.73287 17.8875C3.97558 14.4464 5.44804 11.2083 7.8841 8.7653L7.88396 8.76544Z"
                fill="black"
            />
        </svg>
    )
}

export const Close = ({ className = '', opacity = '0.4' }: React.SVGProps<SVGSVGElement>): JSX.Element => {
    return (
        <svg
            className={className}
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity={opacity}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.51386 14.4497C0.53755 15.426 0.53755 17.009 1.51386 17.9853C2.49017 18.9616 4.07308 18.9616 5.0494 17.9853L9.9989 13.0358L14.9485 17.9854C15.9248 18.9617 17.5077 18.9617 18.484 17.9854C19.4604 17.0091 19.4604 15.4261 18.484 14.4498L13.5344 9.50023L18.4844 4.55024C19.4607 3.57393 19.4607 1.99101 18.4844 1.0147C17.5081 0.0383929 15.9252 0.0383932 14.9489 1.0147L9.9989 5.96469L5.04902 1.01481C4.07271 0.0384963 2.48979 0.0384963 1.51348 1.01481C0.537172 1.99112 0.537173 3.57403 1.51348 4.55034L6.46337 9.50023L1.51386 14.4497Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Close2 = ({ className = '', fill = '#F54E00' }: { className: string; fill?: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill={fill}
                fillRule="evenodd"
                d="M6.414 4.414a1.414 1.414 0 0 0-2 2l4 4-4 4a1.414 1.414 0 0 0 2 2l4-4 4 4a1.414 1.414 0 1 0 2-2l-4-4 4-4a1.414 1.414 0 1 0-2-2l-4 4-4-4Z"
                clipRule="evenodd"
            />
        </svg>
    )
}

export const Lightning = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.4114 12.2086H15.9883L18.5925 2.91284C18.7609 2.35284 18.0325 1.98861 17.6683 2.43706L7.19571 14.9245C6.91571 15.2603 7.13993 15.7929 7.58727 15.7929H12.0115L9.40732 25.0887C9.23889 25.6487 9.96732 26.0129 10.3315 25.5644L20.8315 13.0759C21.1115 12.7401 20.86 12.2085 20.4115 12.2085L20.4114 12.2086Z"
                fill="black"
            />
        </svg>
    )
}

export const Browser = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M25.34 2.82857H2.66C1.56844 2.82857 0.699997 3.72434 0.699997 4.78857V23.2128C0.699997 24.3044 1.59577 25.1728 2.66 25.1728H25.3114C26.403 25.1728 27.2714 24.2771 27.2714 23.2128V4.78857C27.2999 3.69592 26.4041 2.82857 25.3399 2.82857H25.34ZM9.1 4.84434C9.57577 4.84434 9.94 5.2359 9.94 5.68434C9.94 6.13279 9.54844 6.52434 9.1 6.52434C8.62422 6.52434 8.26 6.13279 8.26 5.68434C8.26 5.2359 8.62422 4.84434 9.1 4.84434ZM6.52422 4.84434C7 4.84434 7.36422 5.2359 7.36422 5.68434C7.36422 6.13279 6.97267 6.52434 6.52422 6.52434C6.04845 6.52434 5.68422 6.13279 5.68422 5.68434C5.68422 5.2359 6.07577 4.84434 6.52422 4.84434ZM3.94844 4.84434C4.42422 4.84434 4.78844 5.2359 4.78844 5.68434C4.78844 6.13279 4.39689 6.52434 3.94844 6.52434C3.5 6.52434 3.10844 6.13279 3.10844 5.68434C3.10844 5.2359 3.5 4.84434 3.94844 4.84434ZM25.4799 23.2118C25.4799 23.296 25.4241 23.3518 25.3399 23.3518H2.65989C2.57567 23.3518 2.51989 23.296 2.51989 23.2118V8.56862H25.4799V23.2118Z"
                fill="black"
            />
            <path
                d="M12.18 20.3C12.4042 20.5242 12.7958 20.5242 13.02 20.3L19.4314 13.8886C19.6556 13.6643 19.6556 13.2728 19.4314 13.0486L18.143 11.7601C17.9188 11.5359 17.5272 11.5359 17.303 11.7601L12.5998 16.4358L10.6956 14.5316C10.4714 14.3074 10.0798 14.3074 9.8556 14.5316L8.56715 15.8201C8.34293 16.0443 8.34293 16.4358 8.56715 16.6601L12.18 20.3Z"
                fill="black"
            />
        </svg>
    )
}

export const Slack = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.59936 0C5.60435 0.000733945 4.79907 0.806605 4.7998 1.79963C4.79907 2.79266 5.60508 3.59853 6.6001 3.59927H8.40039V1.80037C8.40112 0.807339 7.59511 0.00146789 6.59936 0C6.6001 0 6.6001 0 6.59936 0V0ZM6.59936 4.8H1.80005C0.805036 4.80073 -0.000977545 5.6066 -0.000242131 6.59963C-0.00171296 7.59266 0.804301 8.39853 1.79932 8.4H6.59936C7.59438 8.39926 8.40039 7.59339 8.39965 6.60037C8.40039 5.6066 7.59438 4.80073 6.59936 4.8Z"
                fill="#36C5F0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.0003 6.59963C18.001 5.6066 17.195 4.80073 16.2 4.8C15.2049 4.80073 14.3989 5.6066 14.3997 6.59963V8.4H16.2C17.195 8.39926 18.001 7.59339 18.0003 6.59963ZM13.2002 6.59963V1.79963C13.2009 0.807339 12.3957 0.00146789 11.4006 0C10.4056 0.000733945 9.59961 0.806605 9.60034 1.79963V6.59963C9.59887 7.59266 10.4049 8.39853 11.3999 8.4C12.3949 8.39926 13.2009 7.59339 13.2002 6.59963Z"
                fill="#2EB67D"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3999 18C12.3949 17.9992 13.2009 17.1934 13.2002 16.2003C13.2009 15.2073 12.3949 14.4014 11.3999 14.4007H9.59961V16.2003C9.59887 17.1926 10.4049 17.9985 11.3999 18ZM11.3999 13.1992H16.1999C17.195 13.1985 18.001 12.3926 18.0002 11.3996C18.0017 10.4066 17.1957 9.60071 16.2007 9.59924H11.4006C10.4056 9.59998 9.59961 10.4058 9.60035 11.3989C9.59961 12.3926 10.4049 13.1985 11.3999 13.1992Z"
                fill="#ECB22E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.02849e-07 11.3996C-0.000734912 12.3926 0.80528 13.1985 1.8003 13.1992C2.79531 13.1985 3.60133 12.3926 3.60059 11.3996V9.59998H1.8003C0.80528 9.60071 -0.000734912 10.4066 5.02849e-07 11.3996ZM4.80005 11.3996V16.1996C4.79858 17.1926 5.6046 17.9985 6.59961 18C7.59463 17.9993 8.40064 17.1934 8.39991 16.2004V11.4011C8.40138 10.4081 7.59536 9.60218 6.60035 9.60071C5.6046 9.60071 4.79932 10.4066 4.80005 11.3996C4.80005 11.3996 4.80005 11.4003 4.80005 11.3996Z"
                fill="#E01E5A"
            />
        </svg>
    )
}

export const SlackMonochrome = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.59936 0C5.60435 0.000733945 4.79907 0.806605 4.7998 1.79963C4.79907 2.79266 5.60508 3.59853 6.6001 3.59927H8.40039V1.80037C8.40112 0.807339 7.59511 0.00146789 6.59936 0C6.6001 0 6.6001 0 6.59936 0V0ZM6.59936 4.8H1.80005C0.805036 4.80073 -0.000977545 5.6066 -0.000242131 6.59963C-0.00171296 7.59266 0.804301 8.39853 1.79932 8.4H6.59936C7.59438 8.39926 8.40039 7.59339 8.39965 6.60037C8.40039 5.6066 7.59438 4.80073 6.59936 4.8Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.0003 6.59963C18.001 5.6066 17.195 4.80073 16.2 4.8C15.2049 4.80073 14.3989 5.6066 14.3997 6.59963V8.4H16.2C17.195 8.39926 18.001 7.59339 18.0003 6.59963ZM13.2002 6.59963V1.79963C13.2009 0.807339 12.3957 0.00146789 11.4006 0C10.4056 0.000733945 9.59961 0.806605 9.60034 1.79963V6.59963C9.59887 7.59266 10.4049 8.39853 11.3999 8.4C12.3949 8.39926 13.2009 7.59339 13.2002 6.59963Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3999 18C12.3949 17.9992 13.2009 17.1934 13.2002 16.2003C13.2009 15.2073 12.3949 14.4014 11.3999 14.4007H9.59961V16.2003C9.59887 17.1926 10.4049 17.9985 11.3999 18ZM11.3999 13.1992H16.1999C17.195 13.1985 18.001 12.3926 18.0002 11.3996C18.0017 10.4066 17.1957 9.60071 16.2007 9.59924H11.4006C10.4056 9.59998 9.59961 10.4058 9.60035 11.3989C9.59961 12.3926 10.4049 13.1985 11.3999 13.1992Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.02849e-07 11.3996C-0.000734912 12.3926 0.80528 13.1985 1.8003 13.1992C2.79531 13.1985 3.60133 12.3926 3.60059 11.3996V9.59998H1.8003C0.80528 9.60071 -0.000734912 10.4066 5.02849e-07 11.3996ZM4.80005 11.3996V16.1996C4.79858 17.1926 5.6046 17.9985 6.59961 18C7.59463 17.9993 8.40064 17.1934 8.39991 16.2004V11.4011C8.40138 10.4081 7.59536 9.60218 6.60035 9.60071C5.6046 9.60071 4.79932 10.4066 4.80005 11.3996C4.80005 11.3996 4.80005 11.4003 4.80005 11.3996Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const ThumbsUp = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.0001 7.71892C18.0001 6.93103 17.381 6.31297 16.5942 6.31297L12.3752 6.31192C12.1506 6.31192 11.3627 5.9744 11.9818 5.01775C12.3752 4.28684 12.3752 1.52976 12.3752 1.52976C12.3752 0.742917 11.7561 0.124863 10.9693 0.124863C10.1814 0.124863 9.5623 0.742944 9.5623 1.53081C9.5623 5.63686 5.625 6.87513 5.625 6.87513V14.1876C7.42543 14.8067 7.87473 15.8751 10.1255 15.8751H14.3445C15.1323 15.8751 15.7504 15.256 15.7504 14.4692C15.7504 14.1317 15.6375 13.85 15.4688 13.6254C16.2567 13.6254 16.8747 13.0063 16.8747 12.2195C16.8747 11.8819 16.7619 11.5444 16.5372 11.2628C17.0994 11.0381 17.4369 10.5319 17.4369 9.96865C17.4369 9.63113 17.324 9.29362 17.0994 9.012C17.6067 8.84324 18.0001 8.33697 18.0001 7.71889V7.71892Z"
                fill="#2AC276"
            />
            <path
                d="M2.81189 5.74973H0V15.313H2.81297C3.76962 15.313 4.50054 14.5251 4.50054 13.6254L4.49949 7.43729C4.49949 6.48064 3.76857 5.74973 2.81192 5.74973H2.81189Z"
                fill="#2AC276"
            />
        </svg>
    )
}

export const ThumbsUpOutline = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.75 10.75H3.75C3.19772 10.75 2.75 11.1977 2.75 11.75V19.25C2.75 19.8023 3.19772 20.25 3.75 20.25H6.75M6.75 20.25V11L10.7208 3.29204C10.8922 2.95918 11.2365 2.75 11.611 2.75C12.8384 2.75 13.7808 3.84535 13.5917 5.0581L13.0161 8.75H18.2589C20.0956 8.75 21.5011 10.3856 21.2248 12.2013L20.3878 17.7013C20.1648 19.167 18.9046 20.25 17.422 20.25H6.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const ThumbsDown = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M-0.000108719 8.28108C-0.000108719 9.06897 0.619026 9.68703 1.40584 9.68703L5.62476 9.68808C5.84941 9.68808 6.6373 10.0256 6.01816 10.9822C5.62476 11.7132 5.62476 14.4702 5.62476 14.4702C5.62476 15.2571 6.24389 15.8751 7.0307 15.8751C7.81859 15.8751 8.4377 15.2571 8.4377 14.4692C8.4377 10.3631 12.375 9.12487 12.375 9.12487L12.375 1.81244C10.5746 1.1933 10.1253 0.124869 7.87446 0.124869L3.65554 0.124869C2.86765 0.124869 2.24959 0.744004 2.24959 1.53082C2.24959 1.86833 2.36245 2.14995 2.53122 2.3746C1.74332 2.3746 1.12527 2.99373 1.12527 3.78055C1.12527 4.11806 1.23813 4.45557 1.46278 4.73719C0.90062 4.96185 0.563107 5.46811 0.563107 6.03135C0.563107 6.36887 0.675963 6.70638 0.90062 6.988C0.393297 7.15676 -0.000108719 7.66303 -0.000108719 8.28111V8.28108Z"
                fill="#F54E00"
            />
            <path
                d="M15.1881 10.2503H18V0.687034H15.187C14.2304 0.687034 13.4995 1.47493 13.4995 2.3746L13.5005 8.56271C13.5005 9.51936 14.2314 10.2503 15.1881 10.2503H15.1881Z"
                fill="#F54E00"
            />
        </svg>
    )
}

export const ThumbsDownOutline = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.2521 13.25H20.25C20.8023 13.25 21.25 12.8023 21.25 12.25V4.75C21.25 4.19772 20.8023 3.75 20.25 3.75H17.2521M17.2521 3.75V13L13.2835 20.7078C13.112 21.0407 12.7635 21.25 12.389 21.25V21.25C11.1622 21.25 10.2249 20.1546 10.4139 18.9419L10.9892 15.25H5.74908C3.91335 15.25 2.50859 13.6144 2.78476 11.7987L3.62128 6.29867C3.84421 4.83298 5.1038 3.75 6.5856 3.75H17.2521Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const Android = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="14" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 14">
            <path
                d="M17.855 4.055l1.99-3.449A.404.404 0 0019.7.055a.4.4 0 00-.55.146l-2.016 3.493A12.302 12.302 0 0012 2.6c-1.863 0-3.595.392-5.134 1.094L4.85.201a.402.402 0 00-.551-.146.402.402 0 00-.146.551l1.99 3.449C2.71 5.915.384 9.39 0 13.458h24c-.384-4.068-2.71-7.543-6.145-9.403zM6.49 10.088a1.006 1.006 0 110-2.013 1.006 1.006 0 010 2.013zm11.018 0a1.006 1.006 0 110-2.013 1.006 1.006 0 010 2.013z"
                fill="#32DE84"
            ></path>
        </svg>
    )
}

export const AWS = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 15">
            <path
                d="M6.821 5.242c0 .292.032.53.087.703.063.173.142.363.253.568a.34.34 0 01.055.182c0 .079-.047.158-.15.237l-.497.331a.378.378 0 01-.206.071c-.079 0-.158-.04-.237-.11a2.443 2.443 0 01-.284-.371 6.11 6.11 0 01-.245-.466c-.615.726-1.389 1.09-2.32 1.09-.664 0-1.193-.19-1.58-.569-.386-.379-.584-.884-.584-1.516 0-.67.237-1.216.719-1.626.481-.41 1.12-.616 1.934-.616.268 0 .545.024.837.063.292.04.592.103.908.174V2.81c0-.6-.127-1.019-.371-1.264-.253-.244-.68-.363-1.287-.363A3.6 3.6 0 003 1.286a6.293 6.293 0 00-.853.268 2.264 2.264 0 01-.276.103.484.484 0 01-.126.024c-.11 0-.166-.08-.166-.245V1.05c0-.126.016-.221.055-.276.04-.056.11-.11.221-.166.277-.142.608-.26.995-.355a4.77 4.77 0 011.232-.15c.94 0 1.626.213 2.068.64.434.425.655 1.073.655 1.941v2.558h.016zm-3.205 1.2c.26 0 .529-.047.813-.142a1.76 1.76 0 00.75-.505c.126-.15.221-.316.268-.505.048-.19.08-.419.08-.687V4.27a6.594 6.594 0 00-.727-.134 5.948 5.948 0 00-.742-.047c-.529 0-.916.102-1.176.315-.26.213-.387.513-.387.908 0 .371.095.648.292.837.19.197.466.292.829.292zm6.34.853c-.143 0-.237-.024-.3-.08-.064-.047-.119-.157-.166-.307L7.634.805a1.383 1.383 0 01-.07-.315c0-.127.062-.198.189-.198h.773c.15 0 .253.024.308.08.063.046.11.157.158.307l1.326 5.226L11.55.68c.04-.158.087-.26.15-.308a.543.543 0 01.316-.079h.632c.15 0 .252.024.315.08.063.046.119.157.15.307l1.248 5.29L15.726.68c.048-.158.103-.26.158-.308a.515.515 0 01.308-.079h.734c.127 0 .198.063.198.198 0 .039-.008.078-.016.126a1.13 1.13 0 01-.055.197L15.15 6.916c-.047.158-.103.26-.166.308a.505.505 0 01-.3.079h-.679c-.15 0-.252-.024-.315-.08-.064-.055-.119-.157-.15-.315l-1.224-5.092L11.1 6.9c-.04.158-.087.26-.15.316-.063.055-.174.079-.316.079h-.679zm10.144.213c-.41 0-.82-.047-1.216-.142-.394-.095-.702-.198-.908-.316-.126-.071-.213-.15-.244-.221a.557.557 0 01-.048-.221v-.403c0-.165.063-.244.182-.244a.44.44 0 01.142.023c.047.016.118.048.197.08.269.118.56.212.869.276.316.063.623.094.94.094.497 0 .884-.087 1.152-.26a.85.85 0 00.41-.75.769.769 0 00-.213-.553c-.142-.15-.41-.284-.797-.41l-1.145-.356c-.576-.181-1.002-.45-1.263-.805a1.881 1.881 0 01-.395-1.145c0-.331.071-.623.213-.876a2.03 2.03 0 01.569-.647c.237-.182.505-.316.82-.41a3.41 3.41 0 01.996-.135c.173 0 .355.008.529.031.181.024.347.056.513.087.158.04.308.08.45.127.142.047.252.094.331.142.11.063.19.126.237.197.047.063.071.15.071.26v.372c0 .165-.063.252-.181.252a.822.822 0 01-.3-.094 3.611 3.611 0 00-1.516-.308c-.45 0-.805.07-1.05.22s-.371.38-.371.703c0 .221.079.41.237.56.157.15.45.3.868.435l1.121.355c.569.182.98.435 1.224.758.244.324.363.695.363 1.106 0 .339-.071.647-.205.915a2.123 2.123 0 01-.577.695c-.244.197-.537.34-.876.442-.355.11-.726.166-1.129.166z"
                fill="currentColor"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.592 11.345c-2.597 1.918-6.37 2.936-9.615 2.936-4.548 0-8.645-1.681-11.74-4.476-.245-.22-.024-.52.268-.347 3.348 1.942 7.477 3.118 11.748 3.118 2.881 0 6.047-.6 8.96-1.831.434-.198.806.284.38.6z"
                fill="#F90"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.674 10.113c-.332-.426-2.195-.205-3.04-.102-.253.031-.292-.19-.063-.356 1.484-1.042 3.924-.742 4.208-.394.284.355-.08 2.794-1.468 3.963-.214.181-.419.087-.324-.15.316-.782 1.018-2.542.687-2.96z"
                fill="#F90"
            ></path>
        </svg>
    )
}

export const Azure = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="19" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 19">
            <path
                d="M11.103 17.597l5.66-1.002.053-.011-2.911-3.463a495.618 495.618 0 01-2.912-3.479c0-.017 3.006-8.295 3.023-8.324.006-.01 2.052 3.522 4.959 8.56l4.987 8.645.038.066h-9.252l-9.251-.002 5.606-.99zM0 16.54c0-.005 1.372-2.386 3.048-5.292l3.048-5.282 3.554-2.98A1273.23 1273.23 0 0113.213 0a.628.628 0 01-.057.144L9.298 8.417 5.51 16.543l-2.755.003c-1.515.002-2.755 0-2.755-.005z"
                fill="#0089D6"
            ></path>
        </svg>
    )
}

export const DigitalOcean = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12.002 24v-4.654c4.926 0 8.75-4.885 6.858-10.07a6.968 6.968 0 00-4.15-4.136C9.525 3.262 4.64 7.072 4.64 11.998H0C0 4.147 7.593-1.976 15.825.595c3.593 1.13 6.464 3.987 7.58 7.58C25.977 16.407 19.853 24 12.002 24z"
                fill="#0080FF"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.015 19.373h-4.64v-4.64h4.64v4.64zm-4.64 3.552H3.823v-3.552h3.552v3.552z"
                fill="#0080FF"
            ></path>
            <path fillRule="evenodd" clipRule="evenodd" d="M3.824 19.374H.844v-2.98h2.98v2.98z" fill="#0080FF"></path>
        </svg>
    )
}

export const Docker = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 18">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.028 2.258h2.119a.186.186 0 00.186-.185V.185A.186.186 0 0013.147 0h-2.119a.185.185 0 00-.184.185v1.888c0 .102.082.185.184.185zM7.255 4.974H5.136a.187.187 0 01-.186-.186V2.9c0-.103.084-.185.186-.185h2.119c.102 0 .184.083.184.185v1.887a.186.186 0 01-.184.186zM21.809 5.99c1.282 0 1.89.458 1.954.51l.237.187-.098.288a2.925 2.925 0 01-.707 1.046c-.465.46-1.308 1.009-2.68 1.009h-.22c-.556 1.403-1.302 2.982-2.554 4.4-.75.848-1.63 1.57-2.61 2.136a12.248 12.248 0 01-3.823 1.39 15.75 15.75 0 01-2.93.265c-2.175 0-4.095-.414-5.276-1.137-1.054-.644-1.864-1.696-2.409-3.124-.476-1.3-.71-2.677-.692-4.062a.751.751 0 01.75-.747h15.81c.193-.008 1.148-.09 1.743-.421-.493-.78-.633-1.69-.403-2.661a4.6 4.6 0 01.611-1.43l.227-.327.344.199c.064.037 1.469.866 1.716 2.565a6.233 6.233 0 011.01-.086zM4.335 7.689H2.217a.185.185 0 01-.185-.185V5.616c0-.103.082-.185.185-.185h2.119c.102 0 .185.083.184.186v1.887a.185.185 0 01-.185.185zm.801 0h2.119a.185.185 0 00.184-.185V5.617a.185.185 0 00-.183-.186h-2.12a.186.186 0 00-.186.186v1.887c0 .102.084.185.186.185zm5.082 0H8.1a.185.185 0 01-.185-.185V5.616c0-.103.083-.185.185-.185h2.119c.103 0 .185.083.184.186v1.887a.185.185 0 01-.185.185zm.81 0h2.119a.186.186 0 00.186-.185V5.617a.186.186 0 00-.186-.186h-2.119a.185.185 0 00-.184.185v1.888c0 .102.082.185.184.185zM8.1 4.974h2.118a.186.186 0 00.185-.186V2.9a.185.185 0 00-.185-.185H8.1a.185.185 0 00-.185.185v1.887c0 .102.083.185.185.186zm5.047 0h-2.119a.186.186 0 01-.184-.186V2.9c0-.102.082-.185.184-.185h2.119c.102 0 .185.082.186.185v1.887a.187.187 0 01-.186.186zm2.955 2.715h-2.119a.185.185 0 01-.185-.185V5.616c0-.103.083-.185.185-.185h2.119c.102 0 .186.083.186.186v1.887a.186.186 0 01-.186.185z"
                fill="#2496ED"
            ></path>
        </svg>
    )
}

export const GCS = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 21">
            <path
                d="M15.69 6.014h.732l2.086-2.086.102-.886C14.728-.385 8.803-.015 5.375 3.868a9.374 9.374 0 00-2.02 3.75c.232-.096.49-.111.732-.044l4.172-.688s.212-.352.323-.33a5.204 5.204 0 017.123-.542h-.015z"
                fill="#EA4335"
            ></path>
            <path
                d="M21.48 7.618a9.391 9.391 0 00-2.832-4.567L15.72 5.978a5.206 5.206 0 011.91 4.13v.52a2.606 2.606 0 010 5.211h-5.21l-.52.528v3.126l.52.52h5.212a6.778 6.778 0 003.85-12.395z"
                fill="#4285F4"
            ></path>
            <path
                d="M7.199 19.98h5.212v-4.172H7.2c-.372 0-.738-.081-1.076-.235l-.732.227-2.1 2.086-.184.732A6.728 6.728 0 007.2 19.98z"
                fill="#34A853"
            ></path>
            <path
                d="M7.199 6.446a6.777 6.777 0 00-4.091 12.15l3.022-3.022a2.607 2.607 0 012.145-4.75 2.61 2.61 0 011.302 1.303L12.6 9.104a6.762 6.762 0 00-5.401-2.658z"
                fill="#FBBC05"
            ></path>
        </svg>
    )
}

export const HelmChart = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M6.553 5.815l-.086-.083c-.606-.582-1.075-1.254-1.358-2.05a1.782 1.782 0 01-.128-.689c0-.022 0-.045.002-.068.022-.31.229-.466.531-.392.095.024.188.06.275.105.33.166.6.411.848.68A5.401 5.401 0 017.7 4.964c.003.006.01.01.027.025a8.465 8.465 0 013.888-1.193c-.008-.043-.013-.075-.021-.106a5.4 5.4 0 01-.127-1.774A4.02 4.02 0 0111.68.871a1.52 1.52 0 01.263-.488.752.752 0 01.152-.135.337.337 0 01.385-.003.83.83 0 01.28.323c.119.221.204.459.253.705.112.52.146 1.054.102 1.584a4.592 4.592 0 01-.168.955c.342.063.683.112 1.016.191.332.078.66.174.98.289.325.118.642.256.95.41.304.153.594.334.898.507.01-.021.024-.046.034-.072a5.215 5.215 0 011.58-2.245c.167-.144.359-.256.567-.33a.828.828 0 01.176-.04c.301-.035.427.154.45.38a1.46 1.46 0 01-.038.497c-.11.419-.283.819-.515 1.185-.326.526-.713 1-1.204 1.384-.015.011-.027.025-.052.047.48.444.91.941 1.276 1.483a.525.525 0 01-.08.014c-.51 0-1.018-.001-1.526.002a.192.192 0 01-.153-.081 7.098 7.098 0 00-5.686-2.29 7.028 7.028 0 00-3.961 1.526c-.293.23-.565.485-.815.76a.227.227 0 01-.186.085c-.486-.003-.971-.002-1.457-.002h-.103c.03-.115.328-.525.666-.89.252-.273.52-.531.79-.807zM18.938 16.7c-.338.473-.724.91-1.15 1.304l.088.074a5.2 5.2 0 011.617 2.311c.084.22.12.457.106.692a.715.715 0 01-.036.177.346.346 0 01-.391.242 1.066 1.066 0 01-.325-.097 2.456 2.456 0 01-.44-.279 5.165 5.165 0 01-1.582-2.242l-.034-.09a9.338 9.338 0 01-1.201.672 8.719 8.719 0 01-1.281.467 9 9 0 01-1.359.259c.009.04.013.072.021.104.146.57.194 1.162.143 1.749-.02.368-.09.73-.212 1.079a3.768 3.768 0 01-.2.42.643.643 0 01-.113.142c-.19.197-.419.199-.605-.004a1.313 1.313 0 01-.187-.27c-.148-.276-.224-.578-.278-.885a5.611 5.611 0 01-.066-1.27c.015-.311.061-.62.139-.921l.018-.078c.001-.006-.003-.014-.008-.035a8.455 8.455 0 01-3.887-1.2l-.053.117a5.303 5.303 0 01-1.483 1.989c-.17.146-.367.259-.578.334a.58.58 0 01-.313.033.342.342 0 01-.26-.215c-.067-.165-.055-.335-.032-.505a2.66 2.66 0 01.206-.684 5.4 5.4 0 011.273-1.813c.022-.02.045-.04.066-.062a.18.18 0 00.018-.032 8.585 8.585 0 01-1.367-1.503c.048-.003.08-.008.11-.008.506 0 1.01.001 1.515-.003a.226.226 0 01.178.079 7.053 7.053 0 001.891 1.386 6.718 6.718 0 002.386.71c2.261.22 4.207-.467 5.837-2.058a.367.367 0 01.287-.117c.47.006.941.002 1.412.002h.121l.009.029zm-2.103-7.208c.134 0 .263.01.39-.002.144-.013.246.038.351.135.606.558 1.218 1.109 1.827 1.662.03.028.062.055.102.09l.103-.09c.629-.572 1.257-1.144 1.884-1.717a.262.262 0 01.202-.08c.155.007.31.002.473.002v5.058c-.083.024-1.195.03-1.327.003v-2.561l-.026-.013-1.307 1.193-1.318-1.188-.026.01v2.569h-1.317c-.024-.086-.036-4.784-.01-5.07zm-12.149.006h1.309c.026.084.031 4.943.004 5.066H4.69c-.007-.322-.002-.643-.003-.963v-.962H3.064v1.907c-.098.03-1.216.033-1.327.006V9.5H3.06v1.785c.095.027 1.484.032 1.626.006l.001-.435V9.499zm2.877 5.064V9.513c.078-.025 2.955-.035 3.143-.01v1.076c-.042.003-.086.01-.13.01H8.897v.836h1.6v1.114H8.912c-.026.095-.033.759-.012.943.04.002.084.008.128.008h1.679v1.072H7.563zm4.643.002c-.024-.136-.019-4.973.005-5.065h1.304v3.732c.056.003.1.008.144.008h1.688v1.325h-3.14z"
                fill="#130789"
            ></path>
        </svg>
    )
}

export const Heroku = (props): JSX.Element => {
    return (
        <svg {...props} width="22" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 24">
            <path
                d="M19.38 0H2.16C.96 0 0 .96 0 2.16v19.68C0 23.04.96 24 2.16 24h17.22c1.2 0 2.16-.96 2.16-2.16V2.16c0-1.2-.96-2.16-2.16-2.16zm.96 21.84c0 .54-.42.96-.96.96H2.16c-.54 0-.96-.42-.96-.96V2.16c0-.54.42-.96.96-.96h17.22c.54 0 .96.42.96.96v19.68zM5.4 20.4L8.1 18l-2.7-2.4v4.8zm9.72-9.72c-.48-.48-1.38-1.08-2.88-1.08-1.62 0-3.3.42-4.5.84V3.6h-2.4v10.38l1.68-.78s2.76-1.26 5.16-1.26c1.2 0 1.5.66 1.5 1.26v7.2h2.4v-7.2c.06-.18.06-1.5-.96-2.52zM11.94 7.5h2.4c1.08-1.26 1.62-2.52 1.8-3.9h-2.4c-.24 1.38-.84 2.64-1.8 3.9z"
                fill="#430098"
            ></path>
        </svg>
    )
}

export const Ios = (props): JSX.Element => {
    return (
        <svg {...props} width="21" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 24">
            <path
                d="M16.844 23.016c-1.3 1.262-2.736 1.066-4.104.47-1.454-.607-2.784-.645-4.32 0-1.913.826-2.928.586-4.08-.47C-2.164 16.32-1.204 6.12 6.188 5.736c1.793.096 3.048.991 4.104 1.066 1.57-.32 3.072-1.234 4.752-1.114 2.018.163 3.528.96 4.536 2.393-4.152 2.496-3.168 7.968.646 9.504-.764 2.004-1.743 3.984-3.384 5.448l.002-.017zM10.148 5.664C9.954 2.688 12.366.24 15.14 0c.382 3.432-3.12 6-4.992 5.664z"
                fill="currentColor"
            ></path>
        </svg>
    )
}

export const JS = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M24 0H0v24h24V0z" fill="#F7DF1E"></path>
            <path
                d="M16.122 18.75c.483.79 1.112 1.37 2.225 1.37.934 0 1.531-.467 1.531-1.113 0-.773-.613-1.047-1.642-1.497l-.564-.242c-1.627-.693-2.708-1.562-2.708-3.398 0-1.691 1.289-2.979 3.303-2.979 1.434 0 2.465.5 3.207 1.806l-1.756 1.127c-.387-.693-.804-.966-1.451-.966-.66 0-1.08.419-1.08.966 0 .677.42.95 1.387 1.37l.564.241c1.916.822 2.998 1.66 2.998 3.543 0 2.03-1.595 3.143-3.737 3.143-2.095 0-3.448-.998-4.11-2.306l1.833-1.065zm-7.967.196c.354.628.677 1.16 1.452 1.16.74 0 1.208-.29 1.208-1.418V11.02h2.255v7.699c0 2.335-1.369 3.398-3.367 3.398-1.806 0-2.852-.934-3.384-2.06l1.836-1.111z"
                fill="#000"
            ></path>
        </svg>
    )
}

export const NodeJS = (props): JSX.Element => {
    return (
        <svg {...props} width="22" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 24">
            <path
                d="M10.649 24a1.85 1.85 0 01-.923-.247l-2.935-1.738c-.439-.245-.225-.332-.08-.382.584-.204.703-.25 1.327-.605.066-.037.152-.024.219.015l2.255 1.339a.298.298 0 00.273 0l8.794-5.077a.277.277 0 00.134-.237V6.919a.282.282 0 00-.136-.242l-8.79-5.072a.27.27 0 00-.271 0l-8.79 5.072a.28.28 0 00-.139.24v10.149a.27.27 0 00.137.235l2.408 1.391c1.308.654 2.107-.116 2.107-.891V7.785a.25.25 0 01.255-.254h1.114c.139 0 .253.11.253.254v10.02c0 1.744-.95 2.745-2.604 2.745-.509 0-.91 0-2.028-.55L.922 18.67A1.86 1.86 0 010 17.065V6.918c0-.66.352-1.277.922-1.602L9.726.236a1.928 1.928 0 011.849 0l8.792 5.08a1.855 1.855 0 01.922 1.603v10.149a1.86 1.86 0 01-.922 1.602l-8.792 5.079a1.848 1.848 0 01-.927.246"
                fill="#689F63"
            ></path>
            <path
                d="M13.366 17.007c-3.848 0-4.655-1.766-4.655-3.248 0-.14.114-.253.255-.253h1.136c.125 0 .23.091.25.215.172 1.158.683 1.742 3.01 1.742 1.853 0 2.641-.42 2.641-1.402 0-.566-.224-.986-3.104-1.268-2.408-.238-3.896-.768-3.896-2.694 0-1.775 1.497-2.831 4.004-2.831 2.816 0 4.211.977 4.388 3.077a.255.255 0 01-.256.277h-1.142a.252.252 0 01-.247-.198c-.275-1.217-.94-1.607-2.747-1.607-2.023 0-2.259.705-2.259 1.233 0 .64.278.828 3.007 1.189 2.704.359 3.987.865 3.987 2.765 0 1.915-1.598 3.013-4.385 3.013l.013-.01z"
                fill="#689F63"
            ></path>
        </svg>
    )
}

export const ReactIcon = (props): JSX.Element => {
    return (
        <svg {...props} width="23" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 21">
            <g clipPath="url(#clip0)">
                <path d="M11.5 12.282a2.05 2.05 0 100-4.1 2.05 2.05 0 000 4.1z" fill="#61DAFB"></path>
                <path
                    d="M11.5 14.432c6.075 0 11-1.88 11-4.2 0-2.32-4.925-4.2-11-4.2s-11 1.88-11 4.2c0 2.32 4.925 4.2 11 4.2z"
                    stroke="#61DAFB"
                ></path>
                <path
                    d="M7.863 12.332c3.038 5.261 7.129 8.586 9.137 7.426 2.01-1.16 1.175-6.365-1.862-11.626C12.1 2.87 8.009-.454 6 .705c-2.008 1.16-1.174 6.366 1.863 11.627z"
                    stroke="#61DAFB"
                ></path>
                <path
                    d="M7.863 8.132C4.826 13.392 3.992 18.598 6 19.758c2.01 1.16 6.1-2.165 9.138-7.426C18.175 7.07 19.009 1.865 17 .705c-2.008-1.16-6.1 2.165-9.137 7.427z"
                    stroke="#61DAFB"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0">
                    <path fill="#fff" d="M0 0h23v20.463H0z"></path>
                </clipPath>
            </defs>
        </svg>
    )
}

export const Ruby = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g clipPath="url(#clip0)" fillRule="evenodd" clipRule="evenodd">
                <path
                    d="M18.594 15.797L4.892 23.933l17.742-1.203L24 4.84l-5.406 10.957z"
                    fill="url(#paint0_linear)"
                ></path>
                <path d="M22.663 22.717l-1.525-10.525-4.154 5.485 5.68 5.04z" fill="url(#paint1_linear)"></path>
                <path d="M22.683 22.717L11.51 21.84l-6.56 2.07 17.732-1.193z" fill="url(#paint2_linear)"></path>
                <path d="M4.967 23.913l2.79-9.143-6.14 1.313 3.35 7.83z" fill="url(#paint3_linear)"></path>
                <path d="M16.983 17.707L14.414 7.648l-7.349 6.89 9.918 3.17z" fill="url(#paint4_linear)"></path>
                <path d="M23.418 7.79L16.47 2.116 14.536 8.37l8.882-.58z" fill="url(#paint5_linear)"></path>
                <path d="M20.168.093l-4.085 2.258L13.505.063l6.663.03z" fill="url(#paint6_linear)"></path>
                <path d="M0 19.15l1.712-3.122L.327 12.31 0 19.15z" fill="url(#paint7_linear)"></path>
                <path
                    d="M.235 12.192l1.393 3.951 6.053-1.358 6.911-6.422 1.95-6.195L13.472 0 8.25 1.954C6.606 3.484 3.414 6.51 3.299 6.568c-.114.058-2.108 3.826-3.064 5.624z"
                    fill="#fff"
                ></path>
                <path
                    d="M5.126 5.094c3.565-3.535 8.16-5.623 9.925-3.844 1.762 1.78-.107 6.104-3.672 9.637-3.565 3.534-8.104 5.737-9.866 3.958-1.764-1.779.048-6.218 3.613-9.751z"
                    fill="url(#paint8_linear)"
                ></path>
                <path
                    d="M4.967 23.91l2.769-9.173 9.196 2.955c-3.325 3.117-7.023 5.753-11.965 6.217z"
                    fill="url(#paint9_linear)"
                ></path>
                <path
                    d="M14.604 8.345l2.36 9.351c2.778-2.92 5.27-6.06 6.492-9.944l-8.852.593z"
                    fill="url(#paint10_linear)"
                ></path>
                <path
                    d="M23.432 7.8c.945-2.852 1.163-6.942-3.293-7.702l-3.656 2.02L23.432 7.8z"
                    fill="url(#paint11_linear)"
                ></path>
                <path d="M0 19.108c.13 4.707 3.526 4.777 4.972 4.818l-3.34-7.802L0 19.109z" fill="#9E1209"></path>
                <path
                    d="M14.617 8.36c2.134 1.311 6.436 3.946 6.523 3.994.136.077 1.855-2.898 2.245-4.58l-8.768.585z"
                    fill="url(#paint12_radial)"
                ></path>
                <path
                    d="M7.731 14.737l3.702 7.142c2.19-1.187 3.903-2.633 5.473-4.183l-9.175-2.959z"
                    fill="url(#paint13_radial)"
                ></path>
                <path
                    d="M1.617 16.134l-.524 6.245c.99 1.352 2.351 1.47 3.78 1.364-1.034-2.571-3.098-7.713-3.256-7.61z"
                    fill="url(#paint14_linear)"
                ></path>
                <path
                    d="M16.462 2.133l7.354 1.032C23.423 1.502 22.218.43 20.164.093l-3.702 2.04z"
                    fill="url(#paint15_linear)"
                ></path>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear"
                    x1="21.086"
                    y1="26.11"
                    x2="16.023"
                    y2="17.171"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FB7655"></stop>
                    <stop offset=".41" stopColor="#E42B1E"></stop>
                    <stop offset=".99" stopColor="#900"></stop>
                    <stop offset="1" stopColor="#900"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear"
                    x1="23.609"
                    y1="18.601"
                    x2="17.084"
                    y2="14.222"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#871101"></stop>
                    <stop offset=".99" stopColor="#911209"></stop>
                    <stop offset="1" stopColor="#911209"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear"
                    x1="18.387"
                    y1="26.381"
                    x2="11.862"
                    y2="22.002"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#871101"></stop>
                    <stop offset=".99" stopColor="#911209"></stop>
                    <stop offset="1" stopColor="#911209"></stop>
                </linearGradient>
                <linearGradient
                    id="paint3_linear"
                    x1="4.688"
                    y1="15.431"
                    x2="5.699"
                    y2="22.005"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff"></stop>
                    <stop offset=".23" stopColor="#E57252"></stop>
                    <stop offset=".46" stopColor="#DE3B20"></stop>
                    <stop offset=".99" stopColor="#A60003"></stop>
                    <stop offset="1" stopColor="#A60003"></stop>
                </linearGradient>
                <linearGradient
                    id="paint4_linear"
                    x1="11.645"
                    y1="9.293"
                    x2="12.017"
                    y2="16.002"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff"></stop>
                    <stop offset=".23" stopColor="#E4714E"></stop>
                    <stop offset=".56" stopColor="#BE1A0D"></stop>
                    <stop offset=".99" stopColor="#A80D00"></stop>
                    <stop offset="1" stopColor="#A80D00"></stop>
                </linearGradient>
                <linearGradient
                    id="paint5_linear"
                    x1="17.819"
                    y1="3.091"
                    x2="18.935"
                    y2="7.9"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff"></stop>
                    <stop offset=".18" stopColor="#E46342"></stop>
                    <stop offset=".4" stopColor="#C82410"></stop>
                    <stop offset=".99" stopColor="#A80D00"></stop>
                    <stop offset="1" stopColor="#A80D00"></stop>
                </linearGradient>
                <linearGradient
                    id="paint6_linear"
                    x1="14.412"
                    y1="1.398"
                    x2="19.22"
                    y2="-1.006"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff"></stop>
                    <stop offset=".54" stopColor="#C81F11"></stop>
                    <stop offset=".99" stopColor="#BF0905"></stop>
                    <stop offset="1" stopColor="#BF0905"></stop>
                </linearGradient>
                <linearGradient
                    id="paint7_linear"
                    x1=".473"
                    y1="13.755"
                    x2=".869"
                    y2="17.717"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff"></stop>
                    <stop offset=".31" stopColor="#DE4024"></stop>
                    <stop offset=".99" stopColor="#BF190B"></stop>
                    <stop offset="1" stopColor="#BF190B"></stop>
                </linearGradient>
                <linearGradient
                    id="paint8_linear"
                    x1="-2.248"
                    y1="18.788"
                    x2="16.355"
                    y2="-.34"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#BD0012"></stop>
                    <stop offset=".07" stopColor="#fff"></stop>
                    <stop offset=".17" stopColor="#fff"></stop>
                    <stop offset=".27" stopColor="#C82F1C"></stop>
                    <stop offset=".33" stopColor="#820C01"></stop>
                    <stop offset=".46" stopColor="#A31601"></stop>
                    <stop offset=".72" stopColor="#B31301"></stop>
                    <stop offset=".99" stopColor="#E82609"></stop>
                    <stop offset="1" stopColor="#E82609"></stop>
                </linearGradient>
                <linearGradient
                    id="paint9_linear"
                    x1="12.002"
                    y1="20.718"
                    x2="6.398"
                    y2="19.335"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8C0C01"></stop>
                    <stop offset=".54" stopColor="#990C00"></stop>
                    <stop offset=".99" stopColor="#A80D0E"></stop>
                    <stop offset="1" stopColor="#A80D0E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint10_linear"
                    x1="21.625"
                    y1="13.992"
                    x2="16.647"
                    y2="9.531"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#7E110B"></stop>
                    <stop offset=".99" stopColor="#9E0C00"></stop>
                    <stop offset="1" stopColor="#9E0C00"></stop>
                </linearGradient>
                <linearGradient
                    id="paint11_linear"
                    x1="23.454"
                    y1="5.807"
                    x2="20.974"
                    y2="3.156"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#79130D"></stop>
                    <stop offset=".99" stopColor="#9E120B"></stop>
                    <stop offset="1" stopColor="#9E120B"></stop>
                </linearGradient>
                <linearGradient
                    id="paint14_linear"
                    x1="3.231"
                    y1="23.904"
                    x2="1.21"
                    y2="17.048"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8B2114"></stop>
                    <stop offset=".43" stopColor="#9E100A"></stop>
                    <stop offset=".99" stopColor="#B3100C"></stop>
                    <stop offset="1" stopColor="#B3100C"></stop>
                </linearGradient>
                <linearGradient
                    id="paint15_linear"
                    x1="18.732"
                    y1="1.187"
                    x2="23.262"
                    y2="3.186"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B31000"></stop>
                    <stop offset=".44" stopColor="#910F08"></stop>
                    <stop offset=".99" stopColor="#791C12"></stop>
                    <stop offset="1" stopColor="#791C12"></stop>
                </linearGradient>
                <radialGradient
                    id="paint12_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(17.423 9.617) scale(6.09995)"
                >
                    <stop stopColor="#A80D00"></stop>
                    <stop offset=".99" stopColor="#7E0E08"></stop>
                    <stop offset="1" stopColor="#7E0E08"></stop>
                </radialGradient>
                <radialGradient
                    id="paint13_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(8.975 17.655) scale(8.10907)"
                >
                    <stop stopColor="#A30C00"></stop>
                    <stop offset=".99" stopColor="#800E08"></stop>
                    <stop offset="1" stopColor="#800E08"></stop>
                </radialGradient>
                <clipPath id="clip0">
                    <path fill="#fff" d="M0 0h24v23.933H0z"></path>
                </clipPath>
            </defs>
        </svg>
    )
}

export const Shopify = (props): JSX.Element => {
    return (
        <svg {...props} width="22" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 24">
            <g clipPath="url(#clip0)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.975 23.576L14.92 3.011c-.139-.138-.41-.096-.515-.065l-.704.218a4.91 4.91 0 00-.337-.829c-.5-.953-1.23-1.457-2.114-1.458h-.003c-.06 0-.118.005-.177.01h-.006a1.947 1.947 0 00-.08-.091C10.6.384 10.106.184 9.515.2c-1.141.033-2.278.857-3.2 2.32-.648 1.031-1.14 2.325-1.281 3.327l-2.247.696c-.66.208-.681.229-.769.852C1.953 7.868.223 21.252.223 21.252l14.503 2.509.248-.186v.001zM10.223 1.141a1.168 1.168 0 00-.687-.18c-1.761.05-3.297 2.802-3.69 4.636l1.688-.523.301-.093c.221-1.165.776-2.373 1.502-3.15a3.31 3.31 0 01.885-.69zM8.669 4.722l2.422-.75c.008-.63-.06-1.563-.377-2.222-.336.139-.619.382-.822.6-.544.584-.988 1.476-1.222 2.372zm3.18-.984l1.127-.35c-.18-.584-.607-1.563-1.473-1.727.27.694.338 1.499.347 2.077z"
                    fill="#95BF47"
                ></path>
                <path
                    d="M18.224 4.542c-.087-.007-1.763-.033-1.763-.033s-1.402-1.362-1.541-1.501a.345.345 0 00-.194-.09v20.84l6.284-1.563S18.445 4.852 18.43 4.734a.228.228 0 00-.206-.192z"
                    fill="#5E8E3E"
                ></path>
                <path
                    d="M11.243 7.777l-.73 2.732s-.814-.37-1.78-.31c-1.416.09-1.43.983-1.416 1.207.077 1.22 3.29 1.488 3.47 4.35.143 2.25-1.193 3.792-3.118 3.912-2.31.146-3.582-1.217-3.582-1.217l.49-2.083s1.28.966 2.304.901c.67-.042.909-.586.885-.972-.101-1.593-2.718-1.5-2.883-4.117-.14-2.205 1.307-4.437 4.5-4.638 1.23-.079 1.86.236 1.86.236"
                    fill="#fff"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0">
                    <path fill="#fff" d="M0 0h21.28v24H0z"></path>
                </clipPath>
            </defs>
        </svg>
    )
}

export const Segment = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="23" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 23">
            <mask id="a" maskUnits="userSpaceOnUse" x="0" y="12" width="23" height="11">
                <path d="M22.704 22.262H0v-9.348h22.704v9.348z" fill="#fff"></path>
            </mask>
            <g mask="url(#a)" fillRule="evenodd" clipRule="evenodd">
                <path
                    d="M14.96 15.22H1.153a1.152 1.152 0 110-2.305h13.809a1.152 1.152 0 110 2.305z"
                    fill="#93C8A2"
                ></path>
                <path
                    d="M12 22.28c-1.125 0-2.236-.168-3.302-.498a1.153 1.153 0 01.683-2.202 8.825 8.825 0 002.62.394c3.91 0 7.305-2.51 8.449-6.246a1.152 1.152 0 012.204.674A11.081 11.081 0 0112 22.28z"
                    fill="#43AF79"
                ></path>
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.848 9.364H9.04a1.152 1.152 0 110-2.304h13.808a1.152 1.152 0 110 2.304z"
                fill="#93C8A2"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.449 9.365a1.153 1.153 0 01-1.102-1.49A11.08 11.08 0 0112 0c1.126 0 2.236.167 3.302.498a1.152 1.152 0 11-.683 2.201A8.915 8.915 0 0012 2.308a8.787 8.787 0 00-8.448 6.246 1.153 1.153 0 01-1.102.815"
                fill="#43AF79"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.993 3.82a1.152 1.152 0 11-2.304.001 1.152 1.152 0 012.304 0zM6.312 18.46a1.152 1.152 0 11-2.304.001 1.152 1.152 0 012.304 0z"
                fill="#93C8A2"
            ></path>
        </svg>
    )
}

export const Sentry = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 22">
            <g clipPath="url(#clip0)">
                <path
                    d="M13.92 1.085a2.242 2.242 0 00-3.84 0l-3.16 5.41a15.46 15.46 0 018.52 12.796h-2.218a13.287 13.287 0 00-7.42-10.905L2.879 13.44a7.641 7.641 0 014.43 5.842H2.218a.366.366 0 01-.298-.533l1.412-2.4a5.155 5.155 0 00-1.613-.912l-1.397 2.4a2.179 2.179 0 00.811 2.995 2.23 2.23 0 001.085.288h6.974a9.312 9.312 0 00-3.84-8.309l1.11-1.92a11.457 11.457 0 014.943 10.23h5.909A17.223 17.223 0 009.436 5.855l2.242-3.84a.37.37 0 01.504-.13c.254.14 9.739 16.69 9.917 16.882a.364.364 0 01-.327.543h-2.285c.03.61.03 1.22 0 1.828h2.295a2.203 2.203 0 001.92-3.307L13.919 1.085z"
                    fill="currentColor"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0">
                    <path fill="#fff" d="M0 0h24v21.12H0z"></path>
                </clipPath>
            </defs>
        </svg>
    )
}

export const WordPress = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 .72a11.21 11.21 0 016.306 1.926 11.37 11.37 0 013.048 3.048A11.209 11.209 0 0123.28 12a11.208 11.208 0 01-1.926 6.306 11.36 11.36 0 01-3.048 3.048A11.209 11.209 0 0112 23.28a11.209 11.209 0 01-6.306-1.926 11.367 11.367 0 01-3.048-3.048A11.209 11.209 0 01.72 12a11.21 11.21 0 011.926-6.306 11.366 11.366 0 013.048-3.048A11.209 11.209 0 0112 .72z"
                fill="currentColor"
            ></path>
            <path
                d="M20.775 7.202c.043.319.068.66.068 1.029 0 1.014-.19 2.155-.761 3.581l-3.054 8.83A9.994 9.994 0 0022 12a9.953 9.953 0 00-1.225-4.798zm-8.6 5.672l-3 8.719a9.995 9.995 0 006.146-.16.91.91 0 01-.072-.138l-3.073-8.42zm6.576-1.379c0-1.236-.444-2.092-.825-2.757-.506-.825-.982-1.522-.982-2.346 0-.919.697-1.775 1.68-1.775.044 0 .086.006.129.008A9.963 9.963 0 0012 2a9.989 9.989 0 00-8.355 4.507c.235.008.456.012.643.012 1.046 0 2.666-.127 2.666-.127.538-.031.602.76.064.824 0 0-.542.064-1.145.095l3.642 10.832 2.188-6.563-1.558-4.269a17.875 17.875 0 01-1.049-.095c-.539-.032-.475-.855.064-.824 0 0 1.651.127 2.633.127 1.046 0 2.666-.127 2.666-.127.54-.031.603.76.064.824 0 0-.543.064-1.145.095l3.614 10.75 1.032-3.27c.458-1.428.727-2.44.727-3.296zM2 12a10 10 0 005.636 9L2.866 7.93A9.96 9.96 0 002 12z"
                fill="currentColor"
            ></path>
        </svg>
    )
}

export const Zapier = (props): JSX.Element => {
    return (
        <svg {...props} width="23" height="23" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
            <path
                d="M13.924 11.144c0 .803-.145 1.6-.428 2.351a6.679 6.679 0 01-2.352.429h-.01c-.803 0-1.6-.145-2.352-.428a6.663 6.663 0 01-.429-2.352v-.01c0-.829.152-1.621.427-2.353a6.656 6.656 0 012.353-.428h.009c.828 0 1.62.152 2.352.428a6.66 6.66 0 01.428 2.352v.01l.002.001zm8.199-1.862H15.62l4.597-4.597a11.184 11.184 0 00-2.626-2.625l-4.597 4.597V.155A11.191 11.191 0 0011.145 0h-.012c-.63 0-1.249.054-1.85.155v6.502l-4.6-4.598c-.506.36-.981.763-1.42 1.203l-.002.002c-.44.44-.842.915-1.202 1.421l4.599 4.597H.155S0 10.504 0 11.135v.008c0 .631.054 1.25.155 1.852h6.503l-4.6 4.597a11.217 11.217 0 002.627 2.625l4.598-4.596v6.502c.601.1 1.218.154 1.848.154h.015c.62 0 1.238-.052 1.848-.154V15.62l4.599 4.598a11.163 11.163 0 002.624-2.624l-4.597-4.599h6.503c.1-.601.154-1.218.154-1.848v-.016c0-.62-.052-1.238-.154-1.849z"
                fill="#FF4A00"
            ></path>
        </svg>
    )
}

export const More = (props): JSX.Element => {
    return (
        <svg {...props} width="19" height="4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 4">
            <path
                fill="#000"
                fillRule="evenodd"
                d="M4.06 2a2 2 0 11-4 0 2 2 0 014 0zm7 0a2 2 0 11-4 0 2 2 0 014 0zm5 2a2 2 0 100-4 2 2 0 000 4z"
                clipRule="evenodd"
            />
        </svg>
    )
}

export const Check = (props): JSX.Element => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
            />
        </svg>
    )
}

export const Check2 = (props): JSX.Element => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m3.995 8.15 3.468 3.47 8.24-8.24a1.305 1.305 0 0 1 1.84 0l.783.782a1.305 1.305 0 0 1 0 1.842L8.46 15.869a1.304 1.304 0 0 1-1.833.008l-5.238-5.15A1.255 1.255 0 0 1 1 9.785c.004-.367.141-.682.409-.934l.772-.726a1.303 1.303 0 0 1 1.814.027V8.15Z"
            />
        </svg>
    )
}

export const Puzzle = (props): JSX.Element => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z" />
        </svg>
    )
}

export const Calendar = (props): JSX.Element => {
    return (
        <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.8336 0.8336C5.8336 0.37344 5.46016 0 5 0C4.53984 0 4.1664 0.37344 4.1664 0.8336V1.66642H2.5C1.11954 1.66642 0 2.78596 0 4.16642V17.5C0 18.8805 1.11954 20 2.5 20H17.5C18.8805 20 20 18.8805 20 17.5V4.16642C20 2.78596 18.8805 1.66642 17.5 1.66642H15.8336V0.8336C15.8336 0.37344 15.4602 0 15 0C14.5398 0 14.1664 0.37344 14.1664 0.8336V1.66642H5.8336V0.8336ZM1.6664 17.5V8.3336H18.3336V17.5C18.3336 17.9602 17.9602 18.3336 17.5 18.3336H2.5C2.03984 18.3336 1.6664 17.9602 1.6664 17.5Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Pipelines = (props): JSX.Element => {
    return (
        <svg {...props} width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.5"
                d="M30.1467 20.4179C30.1568 20.4028 30.1643 20.3864 30.1719 20.3701C30.1832 20.35 30.1958 20.3286 30.2058 20.3072C30.2146 20.2858 30.2197 20.2645 30.226 20.2431C30.231 20.2242 30.2385 20.2066 30.2423 20.1878C30.2586 20.1048 30.2586 20.0193 30.2423 19.9363C30.2385 19.9175 30.231 19.8999 30.226 19.881C30.2197 19.8596 30.2146 19.837 30.2058 19.8169C30.197 19.7955 30.1845 19.7741 30.1719 19.754C30.1631 19.7377 30.1555 19.7213 30.1467 19.7062C30.1229 19.671 30.0965 19.6371 30.0663 19.6069L28.3765 17.9172C28.1251 17.6657 27.7177 17.6657 27.4663 17.9172C27.2148 18.1686 27.2148 18.576 27.4663 18.8274L28.0572 19.4183H23.9886L15.2958 12.9786V9.39792H23.8225C24.7101 9.39792 25.4318 8.67625 25.4318 7.78863V1.60929C25.4318 0.721669 24.7101 0 23.8225 0H5.48047C4.59285 0 3.87118 0.721669 3.87118 1.60929V7.78734C3.87118 8.67496 4.59285 9.39663 5.48047 9.39663H14.0071L14.0084 12.9786L5.31565 19.417H2.33344C1.97763 19.417 1.68973 19.7049 1.68973 20.0607V27.4722L1.09883 26.8825C0.847377 26.6311 0.440018 26.6311 0.188583 26.8825C-0.0628528 27.134 -0.0628689 27.5413 0.188583 27.7928L1.87834 29.4813C2.00406 29.607 2.16876 29.6698 2.33347 29.6698C2.49819 29.6698 2.66286 29.607 2.78861 29.4813L4.47837 27.7928C4.72982 27.5413 4.72982 27.1339 4.47837 26.8825C4.22692 26.6311 3.81956 26.6311 3.56812 26.8825L2.97722 27.4734V20.7044H5.31697L14.2685 27.3363C14.3829 27.4205 14.5162 27.4633 14.6519 27.4633C14.7865 27.4633 14.921 27.4205 15.0354 27.3363L23.9869 20.7044H28.0568L27.4659 21.2953C27.2144 21.5468 27.2144 21.9541 27.4659 22.2056C27.5916 22.3313 27.7563 22.3942 27.921 22.3942C28.0858 22.3942 28.2504 22.3313 28.3762 22.2056L30.0659 20.5158C30.0961 20.4869 30.1225 20.453 30.1464 20.4177L30.1467 20.4179ZM5.15868 7.78881V1.60946C5.15868 1.4347 5.30577 1.2876 5.48053 1.2876H23.8226C23.9973 1.2876 24.1444 1.4347 24.1444 1.60946V7.78752C24.1444 7.96228 23.9973 8.10938 23.8226 8.10938H5.48053C5.30703 8.11063 5.15868 7.96228 5.15868 7.78878V7.78881ZM14.6522 26.0179L6.6109 20.0596L14.6522 14.104L22.6935 20.0596L14.6522 26.0179Z"
                fill="#5B5B5B"
            />
            <path
                d="M14.651 26.0178L6.6097 20.0596L14.651 14.1039L22.6923 20.0596L14.651 26.0178Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Warehouse = (props): JSX.Element => {
    return (
        <svg {...props} width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.14062 9.90662V20.5773H19.7352V9.90662L16.586 7.83789H6.29237L3.14062 9.90662ZM6.69882 13.1712H7.61911C7.75626 12.497 8.35483 11.9869 9.07261 11.9869C9.78654 11.9869 10.3877 12.4983 10.5261 13.1712H16.185C16.3477 13.1712 16.4823 13.3058 16.4823 13.4686C16.4823 13.6314 16.3477 13.7659 16.185 13.7659H10.5261C10.3877 14.4401 9.79038 14.9503 9.07261 14.9503C8.35867 14.9503 7.75755 14.4389 7.61911 13.7659H6.69882C6.53604 13.7659 6.40145 13.6314 6.40145 13.4686C6.40145 13.3058 6.53219 13.1712 6.69882 13.1712ZM6.69882 15.5412H12.3577C12.4961 14.867 13.0934 14.3568 13.8112 14.3568C14.5251 14.3568 15.1262 14.8682 15.2634 15.5412H16.1837C16.3465 15.5412 16.481 15.6757 16.481 15.8385C16.481 16.0013 16.3465 16.1359 16.1837 16.1359H15.2634C15.1262 16.8101 14.5277 17.3202 13.8112 17.3202C13.0972 17.3202 12.4961 16.8088 12.3577 16.1359H6.69882C6.53604 16.1359 6.40145 16.0013 6.40145 15.8385C6.40145 15.6757 6.53219 15.5412 6.69882 15.5412ZM6.69882 17.9111H7.61911C7.75626 17.2369 8.35483 16.7268 9.07261 16.7268C9.78654 16.7268 10.3877 17.2382 10.5261 17.9111H16.185C16.3477 17.9111 16.4823 18.0457 16.4823 18.2085C16.4823 18.3713 16.3477 18.5058 16.185 18.5058H10.5261C10.3877 19.18 9.79038 19.6902 9.07261 19.6902C8.35867 19.6902 7.75755 19.1788 7.61911 18.5058H6.69882C6.53604 18.5058 6.40145 18.3713 6.40145 18.2085C6.40145 18.0457 6.53219 17.9111 6.69882 17.9111Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.771484 22.6523V24.4276H22.1062V22.6523H0.771484Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.84479 21.1699H2.25391V22.0569H20.6237V21.1699H2.84479Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.7368 1.91006C3.7368 3.88521 0.773438 3.88521 0.773438 1.91006C0.773438 -0.0663734 3.7368 -0.0663734 3.7368 1.91006Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.993 1.9099C22.993 3.489 20.623 3.489 20.623 1.9099C20.623 0.329513 22.993 0.329513 22.993 1.9099Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.3839 8.72115L11.438 1.5293L0.492064 8.72115C0.256224 8.87368 0.107534 9.12363 0.0793478 9.40175C0.0498677 9.68117 0.148562 9.9529 0.347232 10.1516C0.65485 10.4592 1.14448 10.5105 1.50978 10.2708L11.2741 3.85429C11.3254 3.82225 11.3792 3.80687 11.4369 3.80687C11.4946 3.80687 11.5497 3.82096 11.5997 3.85429L21.3641 10.2708C21.7294 10.5105 22.219 10.4592 22.5266 10.1516C22.7253 9.95291 22.8201 9.68118 22.7945 9.40175C22.765 9.11976 22.6138 8.87238 22.3818 8.72115H22.3839Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.19336 7.24347H15.6862L11.44 4.45312L7.19336 7.24347Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const OpenSource = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2389_44050)">
                <path
                    d="M12.0009 10.1016C10.9519 10.1016 10.1016 10.9519 10.1016 12.001C10.1016 12.915 10.7475 13.6782 11.6081 13.8591V23.9907C11.7384 23.9954 11.8687 24.001 12.0009 24.001C12.1331 24.001 12.2634 23.9954 12.3937 23.9916V13.8591C13.2543 13.6781 13.9003 12.915 13.9003 12.0009C13.9003 10.9519 13.05 10.1016 12.0009 10.1016L12.0009 10.1016Z"
                    fill="currentColor"
                />
                <path
                    d="M24 12C24 5.37288 18.6271 0 12 0C5.37288 0 0 5.37288 0 12C0 18.2287 4.74648 23.3484 10.8197 23.9419V23.94C10.7897 19.0623 7.84968 15.2952 6.63 13.9407V13.9397C6.63 13.9397 6.12938 13.3388 6.4125 12.6188L8.63437 6.98433C8.63437 6.98433 9.04592 5.94278 9.95812 5.94278L12 5.94372H14.0419C14.955 5.94372 15.3656 6.98527 15.3656 6.98527L17.5875 12.6197C17.8715 13.3397 17.37 13.9407 17.37 13.9407V13.9416C16.1503 15.2963 13.2103 19.0632 13.1803 23.94V23.9419C19.2535 23.3484 24 18.2287 24 12L24 12Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2389_44050">
                    <rect width="24" height="24" fill="currentColor" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const SelfHost = (props): JSX.Element => {
    return (
        <svg {...props} width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.0416 10.9367C16.4028 10.9391 15.8869 11.455 15.8845 12.0938V13.6655H18.2035V12.0938C18.2011 11.4538 17.6816 10.9367 17.0416 10.9367ZM17.0416 7.60519C15.1673 7.60519 13.3691 8.35008 12.0445 9.67589C10.7187 11.0005 9.9738 12.7988 9.9738 14.673C9.9738 16.5472 10.7187 18.3454 12.0445 19.6701C13.3691 20.9959 15.1674 21.7408 17.0416 21.7408C18.9158 21.7408 20.714 20.9959 22.0387 19.6701C23.3645 18.3454 24.1094 16.5472 24.1094 14.673C24.1082 12.7987 23.3621 11.0018 22.0375 9.67713C20.7128 8.35249 18.9158 7.6064 17.0416 7.60519ZM20.7634 18.1683C20.7634 18.5673 20.4392 18.8915 20.0402 18.8915H14.0474C13.6484 18.8915 13.3242 18.5673 13.3242 18.1683V14.3885C13.3242 13.9896 13.6484 13.6653 14.0474 13.6653H14.4379V12.0936C14.4379 10.6545 15.6046 9.48773 17.0438 9.48773C18.4829 9.48773 19.6496 10.6545 19.6496 12.0936V13.6653H20.0402C20.4391 13.6653 20.7633 13.9896 20.7633 14.3885L20.7634 18.1683ZM17.0416 10.9367C16.4028 10.9391 15.8869 11.455 15.8845 12.0938V13.6655H18.2035V12.0938C18.2011 11.4538 17.6816 10.9367 17.0416 10.9367ZM17.0416 10.9367C16.4028 10.9391 15.8869 11.455 15.8845 12.0938V13.6655H18.2035V12.0938C18.2011 11.4538 17.6816 10.9367 17.0416 10.9367ZM0.109499 10.6712V13.4097C0.110704 13.9412 0.542189 14.3727 1.07374 14.3739H8.54669C8.58647 13.0806 8.92517 11.8126 9.53503 10.6712H0.109499ZM2.42849 13.0336C2.36341 13.1011 2.28386 13.1529 2.19707 13.1879C2.10909 13.2264 2.01387 13.2457 1.91744 13.2457C1.82223 13.2457 1.72942 13.2264 1.64264 13.1879C1.46305 13.118 1.32202 12.9769 1.25213 12.7974C1.21356 12.7106 1.19427 12.6178 1.19427 12.5226C1.19307 12.4261 1.21356 12.3309 1.25213 12.2429C1.27141 12.1995 1.29311 12.1573 1.31962 12.1176C1.34494 12.079 1.37386 12.0428 1.40641 12.0115C1.57876 11.8416 1.82466 11.7668 2.06209 11.8138C2.10789 11.8223 2.15369 11.8355 2.19708 11.8524C2.24047 11.8717 2.27904 11.8958 2.32244 11.9199C2.36101 11.9464 2.39716 11.9765 2.4285 12.0115C2.5647 12.1465 2.64064 12.3309 2.64064 12.5225C2.64184 12.7142 2.5659 12.8986 2.42849 13.0336ZM0.109499 5.527V9.22013H10.5137C11.343 8.23179 12.3844 7.44352 13.5608 6.91557V5.52707L0.109499 5.527ZM2.42849 7.88457C2.3622 7.95207 2.28386 8.0051 2.19707 8.04367C2.10788 8.07862 2.01266 8.0967 1.91744 8.0967C1.82343 8.0967 1.73062 8.07862 1.64264 8.04367C1.55465 8.0051 1.4751 7.95206 1.4064 7.88457C1.3389 7.81707 1.28707 7.73632 1.25212 7.64833C1.21355 7.56155 1.19427 7.46874 1.19427 7.37352C1.19427 7.18188 1.2702 6.99745 1.4064 6.86249C1.69326 6.59009 2.14163 6.59009 2.4285 6.86249C2.56349 6.99869 2.63942 7.18191 2.64063 7.37352C2.64304 7.56517 2.5659 7.75081 2.42849 7.88457ZM12.5964 0.373047H1.07362C0.542065 0.374252 0.110578 0.805737 0.109375 1.33729V4.07574H13.5606V1.33729C13.5594 0.805737 13.1279 0.37425 12.5964 0.373047ZM2.42849 2.73542C2.29471 2.87283 2.10907 2.94997 1.91746 2.94756C1.72582 2.94876 1.54139 2.87283 1.40643 2.73542C1.27023 2.60043 1.19429 2.41601 1.19429 2.22439C1.1955 2.03275 1.27143 1.84956 1.40643 1.71336C1.47633 1.64948 1.55589 1.59644 1.64266 1.55908C1.68605 1.5398 1.73065 1.52533 1.77766 1.51569C1.87167 1.49641 1.9681 1.49641 2.06211 1.51569C2.10791 1.52533 2.15372 1.5398 2.19711 1.55908C2.2405 1.57836 2.28268 1.60006 2.32246 1.62658C2.36103 1.65189 2.39719 1.68082 2.42852 1.71336C2.56352 1.84956 2.63945 2.03278 2.64066 2.22439C2.64307 2.41603 2.5659 2.60166 2.42849 2.73542Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Autocapture = (props): JSX.Element => {
    return (
        <svg {...props} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.5468 9.29236C15.3449 8.23345 14.8406 7.22478 14.0082 6.39242C11.8392 4.22336 8.30869 4.22336 6.11507 6.39242C3.94602 8.56147 3.94602 12.0919 6.11507 14.2856C6.97204 15.1425 8.05657 15.6725 9.16682 15.8488L8.58663 14.0836C8.08229 13.8817 7.62819 13.5793 7.22532 13.201C5.66208 11.6378 5.66208 9.09042 7.22532 7.52723C8.78857 5.96398 11.3359 5.96398 12.8991 7.52723C13.2518 7.87986 13.5295 8.28373 13.7059 8.71222L15.5468 9.29236Z"
                fill="currentColor"
            />
            <path
                d="M10.5299 19.9332L10.0255 18.3945C7.98257 18.3945 5.94065 17.6124 4.35174 16.0491C1.19963 12.897 1.22535 7.80347 4.35174 4.65136C7.50385 1.49925 12.5974 1.49925 15.7495 4.65136C17.2625 6.16437 18.0447 8.156 18.0949 10.1489L19.6581 10.6789C19.7586 8.10698 18.8012 5.50939 16.8586 3.54222C13.1017 -0.214594 6.99825 -0.214594 3.24144 3.54222C-0.515375 7.29903 -0.515375 13.4025 3.24144 17.1593C5.25977 19.1521 7.93228 20.085 10.5296 19.9332L10.5299 19.9332Z"
                fill="currentColor"
            />
            <path
                d="M10.2269 9.16569C9.87423 9.03961 9.49598 9.14008 9.24381 9.39225C8.99164 9.64442 8.89117 10.0227 9.01725 10.3753L13.5563 24.0181C13.7828 24.6988 14.7167 24.749 15.0437 24.1186L17.8175 18.3445C17.8934 18.1928 18.0195 18.0421 18.1958 17.9662L23.97 15.1923C24.626 14.8899 24.5501 13.9315 23.8695 13.705L10.2269 9.16569Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Compliance = (props): JSX.Element => {
    return (
        <svg {...props} width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.71429 0L0.857143 3.71429C0.328114 5.53014 0 7.058 0 9.14286C0 16.3403 4.31686 22.5714 9.71429 24C15.1117 22.5714 19.4286 16.3403 19.4286 9.14286C19.4286 7.05803 19.1005 5.53 18.5714 3.71429L9.71429 0ZM9.71429 7.14286C11.1339 7.14286 12.2857 8.29463 12.2857 9.71429V11.4286H13.1429V16H6.28571V11.4286H7.14286V9.71429C7.14286 8.29463 8.29463 7.14286 9.71429 7.14286ZM9.71429 7.71429C8.60157 7.71429 7.71429 8.60157 7.71429 9.71429V11.4286H11.7143V9.71429C11.7143 8.60157 10.827 7.71429 9.71429 7.71429Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Heatmaps = (props): JSX.Element => {
    return (
        <svg {...props} width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.5455 14.8469C22.6816 14.8469 24.4133 13.1152 24.4133 10.9791C24.4133 8.84299 22.6816 7.11133 20.5455 7.11133C18.4094 7.11133 16.6777 8.84299 16.6777 10.9791C16.6777 13.1152 18.4094 14.8469 20.5455 14.8469Z"
                fill="currentColor"
            />
            <path
                d="M12.3629 22.88C15.2384 22.88 17.5695 20.5489 17.5695 17.6734C17.5695 14.7979 15.2384 12.4668 12.3629 12.4668C9.48733 12.4668 7.15625 14.7979 7.15625 17.6734C7.15625 20.5489 9.48733 22.88 12.3629 22.88Z"
                fill="currentColor"
            />
            <path
                d="M6.11551 13.3599C7.67651 13.3599 8.94195 12.0945 8.94195 10.5335C8.94195 8.97247 7.67651 7.70703 6.11551 7.70703C4.55451 7.70703 3.28906 8.97247 3.28906 10.5335C3.28906 12.0945 4.55451 13.3599 6.11551 13.3599Z"
                fill="currentColor"
            />
            <path
                d="M21.5862 22.5826C22.6543 22.5826 23.5201 21.7168 23.5201 20.6487C23.5201 19.5807 22.6543 18.7148 21.5862 18.7148C20.5182 18.7148 19.6523 19.5807 19.6523 20.6487C19.6523 21.7168 20.5182 22.5826 21.5862 22.5826Z"
                fill="currentColor"
            />
            <path
                d="M5.81737 2.9453C6.06385 2.9453 6.26365 2.74549 6.26365 2.49902C6.26365 2.25254 6.06385 2.05273 5.81737 2.05273C5.5709 2.05273 5.37109 2.25254 5.37109 2.49902C5.37109 2.74549 5.5709 2.9453 5.81737 2.9453Z"
                fill="currentColor"
            />
            <path
                d="M2.84277 2.9453C3.08924 2.9453 3.28905 2.74549 3.28905 2.49902C3.28905 2.25254 3.08924 2.05273 2.84277 2.05273C2.59629 2.05273 2.39648 2.25254 2.39648 2.49902C2.39648 2.74549 2.59629 2.9453 2.84277 2.9453Z"
                fill="currentColor"
            />
            <path
                d="M4.33105 2.9453C4.57752 2.9453 4.77733 2.74549 4.77733 2.49902C4.77733 2.25254 4.57752 2.05273 4.33105 2.05273C4.08457 2.05273 3.88477 2.25254 3.88477 2.49902C3.88477 2.74549 4.08457 2.9453 4.33105 2.9453Z"
                fill="currentColor"
            />
            <path d="M1.05664 4.13606H26.9847V3.54102H1.05664V4.13606Z" fill="currentColor" />
            <path
                d="M1.50324 1.45832V25.855H26.495V1.45832H1.50324ZM1.50324 0.863281H26.495C26.6528 0.863281 26.8041 0.925973 26.9157 1.03756C27.0273 1.14916 27.09 1.30051 27.09 1.45832V25.855C27.09 26.0128 27.0273 26.1642 26.9157 26.2758C26.8041 26.3874 26.6528 26.4501 26.495 26.4501H1.50324C1.34543 26.4501 1.19408 26.3874 1.08249 26.2758C0.970895 26.1642 0.908203 26.0128 0.908203 25.855V1.45832C0.908203 1.30051 0.970895 1.14916 1.08249 1.03756C1.19408 0.925973 1.34543 0.863281 1.50324 0.863281V0.863281Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Platform = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2577_42189)">
                <path
                    d="M23.7743 16.0989L23.8493 16.2171C24.1483 16.7552 23.9899 17.4236 23.5015 17.7742L23.3833 17.8492L12.5833 23.8492C12.2655 24.0255 11.8887 24.0471 11.5568 23.9149L11.4171 23.8492L0.617107 17.8492C0.0377236 17.5277 -0.17038 16.7964 0.151172 16.2171C0.450235 15.6799 1.10179 15.4614 1.65679 15.6902L1.78335 15.7511L11.9992 21.4259L22.2169 15.7511C22.7551 15.4521 23.4235 15.6105 23.7741 16.0989H23.7743ZM23.7743 11.2989L23.8493 11.4171C24.1483 11.9552 23.9899 12.6236 23.5015 12.9742L23.3833 13.0492L12.5833 19.0492C12.2655 19.2255 11.8887 19.2471 11.5568 19.1149L11.4171 19.0492L0.617107 13.0492C0.0377236 12.7277 -0.17038 11.9964 0.151172 11.4171C0.450235 10.8799 1.10179 10.6614 1.65679 10.8902L1.78335 10.9511L11.9992 16.6259L22.2169 10.9511C22.7551 10.6521 23.4235 10.8105 23.7741 11.2989H23.7743ZM11.4172 0.151171C11.78 -0.0503904 12.2206 -0.0503904 12.5834 0.151171L23.3834 6.15117C24.2056 6.60866 24.2056 7.79179 23.3834 8.2493L12.5834 14.2493C12.2206 14.4509 11.78 14.4509 11.4172 14.2493L0.61716 8.2493C-0.205032 7.79181 -0.205032 6.60868 0.61716 6.15117L11.4172 0.151171ZM12.0003 2.57277L3.67157 7.20021L11.9993 11.8257L20.328 7.20021L12.0003 2.57277Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2577_42189">
                    <rect width="24" height="24" fill="currentColor" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const Playlist = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#a)">
                <path d="M15.51 12.044a.802.802 0 0 0-1.218.686v7.54a.802.802 0 0 0 1.217.686l6.22-3.77a.802.802 0 0 0 0-1.372l-6.22-3.77Z" />
                <path
                    fillRule="evenodd"
                    d="M2.5 5.75A.75.75 0 0 1 3.25 5h13.51a.75.75 0 0 1 0 1.5H3.25a.75.75 0 0 1-.75-.75Zm0 6.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 2.5 12Zm0 6.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z"
                    clipRule="evenodd"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const Dashboards = (props): JSX.Element => {
    return (
        <svg {...props} width="36" height="20" viewBox="0 0 36 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.75">
                <path
                    d="M22.803 0.797574C21.2111 0.384959 19.6214 0.150391 17.971 0.150391C8.07236 0.150391 0 8.22275 0 18.1214C0 18.6513 0.471263 19.1226 1.00118 19.1226C1.53108 19.1226 2.00235 18.6513 2.00235 18.1214C2.00235 9.2828 9.19053 2.09408 18.0296 2.09408C19.5021 2.09408 20.9159 2.27002 22.3317 2.68266C22.8616 2.8586 23.3916 2.50673 23.5696 1.97473C23.6869 1.50556 23.3329 0.914892 22.803 0.797627V0.797574Z"
                    fill="currentColor"
                />
                <path
                    d="M31.8179 1.14953C31.4639 0.795554 30.934 0.795554 30.58 1.03223C29.1076 2.03341 16.3795 10.8724 15.024 12.2274C13.3149 13.9365 13.3149 16.764 15.024 18.5319C15.8493 19.3572 16.9677 19.8284 18.1469 19.8284C19.3261 19.8284 20.4446 19.3572 21.2698 18.5319C22.2123 17.5894 26.3364 11.2263 29.2247 6.74804C32.289 9.75366 33.9981 13.8193 33.9981 18.1796C33.9981 18.7095 34.4693 19.1808 34.9992 19.1808C35.5292 19.1808 36.0004 18.7095 36.0004 18.1796C36.0004 13.1131 33.9373 8.45688 30.2846 5.0408C31.1099 3.74429 31.6984 2.74311 31.9351 2.44783C32.2304 1.97448 32.1718 1.44457 31.8178 1.14923L31.8179 1.14953ZM18.7965 16.1752C18.6205 16.3512 18.3838 16.4705 18.0885 16.4705C17.7932 16.4705 17.5586 16.3533 17.3806 16.1752C17.2046 15.9972 17.0874 15.704 17.0874 15.4673C17.0874 15.2306 17.2046 14.9374 17.3827 14.7594C17.7366 14.4054 18.4425 14.4054 18.7965 14.7594C18.9724 14.9353 19.0918 15.2306 19.0918 15.4673C19.0918 15.704 18.9724 15.9385 18.7965 16.1752Z"
                    fill="currentColor"
                />
                <path
                    d="M18.9731 5.33243V4.33125C18.9731 3.80135 18.5018 3.33008 17.9719 3.33008C17.442 3.33008 16.9707 3.80134 16.9707 4.33125V5.33243C16.9707 5.86234 17.442 6.33361 17.9719 6.33361C18.5018 6.3357 18.9731 5.92309 18.9731 5.33243Z"
                    fill="currentColor"
                />
                <path
                    d="M5.89298 16.4692C6.42289 16.4692 6.89416 15.9979 6.89416 15.468C6.89416 14.9381 6.42289 14.4668 5.89298 14.4668H4.8918C4.36189 14.4668 3.89062 14.9381 3.89062 15.468C3.89062 15.9979 4.36189 16.4692 4.8918 16.4692H5.89298Z"
                    fill="currentColor"
                />
                <path
                    d="M31.1098 16.4692C31.6397 16.4692 32.111 15.9979 32.111 15.468C32.111 14.9381 31.6397 14.4668 31.1098 14.4668H30.1086C29.5787 14.4668 29.1074 14.9381 29.1074 15.468C29.1074 15.9979 29.5787 16.4692 30.1086 16.4692H31.1098Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}

export const Annotations = (props): JSX.Element => {
    return (
        <svg {...props} width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.5"
                d="M36 18.5293C36 19.6343 35.105 20.5293 34 20.5293H22.8267L30.7331 28.4224C31.4248 29.2208 31.3814 30.4174 30.6348 31.1641C29.8881 31.9107 28.6915 31.9541 27.8932 31.2624L20 23.356V34.5293C20 35.6343 19.105 36.5293 18 36.5293C16.895 36.5293 16 35.6343 16 34.5293V23.356L8.10685 31.2624C7.30853 31.9541 6.11188 31.9107 5.36522 31.1641C4.61857 30.4174 4.57522 29.2208 5.26689 28.4224L13.1733 20.5293H1.99996C0.895002 20.5293 0 19.6343 0 18.5293C0 17.4243 0.895002 16.5293 1.99996 16.5293H13.1733L5.26689 8.63614C4.57523 7.83782 4.61858 6.64117 5.36522 5.89452C6.11186 5.14787 7.30853 5.10452 8.10685 5.79619L16 13.7026V2.52926C16 1.4243 16.895 0.529297 18 0.529297C19.105 0.529297 20 1.4243 20 2.52926V13.7026L27.8932 5.79619C28.6915 5.10453 29.8881 5.14788 30.6348 5.89452C31.3814 6.64116 31.4248 7.83782 30.7331 8.63614L22.8267 16.5293H34C35.105 16.5293 36 17.4243 36 18.5293Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Extensibility = (props): JSX.Element => {
    return (
        <svg {...props} width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.5">
                <path
                    d="M0 8.0509V22.0321H5.10159C5.19378 22.0321 5.21878 21.9211 5.1719 21.8649C5.09846 21.7758 5.06565 21.7368 4.93752 21.5602C4.68128 21.2055 4.42189 20.6571 4.46409 19.9493C4.50784 19.2134 4.89532 18.6243 5.38128 18.2555C5.8672 17.8883 6.44376 17.7086 6.99064 17.7086C7.53752 17.7086 8.11408 17.8868 8.6 18.2555C9.08591 18.6227 9.47343 19.2133 9.51719 19.9493C9.55938 20.6571 9.30001 21.2055 9.04375 21.5602C8.91563 21.7368 8.88282 21.7774 8.80938 21.8649C8.7625 21.9211 8.7875 22.0321 8.87969 22.0321H13.9813V16.9585C13.9813 16.4335 14.2907 16.0663 14.6735 16.1678C14.9922 16.2522 15.4328 17.0928 16.575 17.0241C17.7172 16.9569 18.3047 15.8788 18.3047 15.0397C18.3047 14.2006 17.7172 13.1241 16.575 13.0554C15.4328 12.9882 14.9922 13.8272 14.6735 13.9116C14.2907 14.0132 13.9813 13.6538 13.9813 13.1304V8.05078L0 8.0509Z"
                    fill="currentColor"
                />
                <path
                    d="M6.9909 18.2501C6.15182 18.2501 5.07526 18.8376 5.00654 19.9798C4.93935 21.122 5.77842 21.5626 5.86278 21.8813C5.96434 22.2642 5.60497 22.5735 5.08154 22.5735H0.00195312V36.5547H13.9831V31.4531C13.9831 31.3609 13.8722 31.3359 13.8159 31.3828C13.7269 31.4562 13.6878 31.4891 13.5112 31.6172C13.1566 31.8734 12.6081 32.1328 11.9003 32.0906C11.1644 32.0469 10.5753 31.6594 10.2066 31.1734C9.83939 30.6875 9.65969 30.1109 9.65969 29.5641C9.65969 29.0172 9.83782 28.4406 10.2066 27.9547C10.5738 27.4688 11.1644 27.0813 11.9003 27.0375C12.6081 26.9953 13.1566 27.2547 13.5112 27.511C13.6878 27.6391 13.7284 27.6719 13.8159 27.7453C13.8722 27.7922 13.9831 27.7672 13.9831 27.675V22.5734H8.90953C8.38453 22.5734 8.01733 22.2641 8.11889 21.8812C8.20327 21.5625 9.04389 21.1219 8.97513 19.9797C8.90794 18.8375 7.82981 18.25 6.99078 18.25L6.9909 18.2501Z"
                    fill="currentColor"
                />
                <path
                    d="M14.5246 22.5742V27.6478C14.5246 28.1728 14.2152 28.5384 13.8324 28.4384C13.5137 28.3541 13.073 27.5134 11.9308 27.5822C10.7886 27.6494 10.2012 28.7275 10.2012 29.5681C10.2012 30.4072 10.7887 31.4838 11.9308 31.5525C13.073 31.6197 13.5136 30.7806 13.8324 30.6962C14.2152 30.5947 14.5246 30.9541 14.5246 31.4775V36.5571H28.5058V22.5759H23.287C22.7995 22.5759 22.4667 22.8634 22.562 23.2181C22.6401 23.5134 23.4198 23.9228 23.3557 24.9837C23.2932 26.0431 22.2933 26.5884 21.5151 26.5884C20.7354 26.5884 19.737 26.0431 19.6729 24.9837C19.6104 23.9244 20.3901 23.515 20.4682 23.2181C20.562 22.8634 20.2214 22.5759 19.7339 22.5759L14.5246 22.5742Z"
                    fill="currentColor"
                />
                <path
                    d="M23.7923 19.5802L28.2219 17.1068C28.6797 16.8505 29.1501 16.9427 29.2485 17.3255C29.3297 17.6443 28.811 18.4396 29.4282 19.4036C30.0438 20.3677 31.2719 20.3552 32.0047 19.9458C32.7375 19.5365 33.3906 18.499 32.8938 17.4693C32.397 16.4396 31.4485 16.463 31.2188 16.2255C30.9438 15.9411 31.1063 15.4958 31.5641 15.2412L36.0001 12.7646L29.1845 0.556641L16.9766 7.37222L19.5203 11.9286C19.7578 12.3536 20.1703 12.5036 20.4344 12.2489C20.6547 12.0364 20.6328 11.1567 21.5875 10.6942C22.5437 10.2333 23.5063 10.8396 23.8859 11.5192C24.2656 12.1989 24.2781 13.338 23.3828 13.9099C22.4891 14.4818 21.75 14.0005 21.4547 14.0755C21.0985 14.1661 21.0141 14.6036 21.2516 15.0286L23.7923 19.5802Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}

export const Cards = (props): JSX.Element => {
    return (
        <svg {...props} width="15" height="22" viewBox="0 0 15 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 1.52422C0 0.684172 0.830781 0 1.85084 0H12.9556C13.9781 0 14.8064 0.684172 14.8064 1.52422V10.6693C14.8064 11.5114 13.9781 12.1936 12.9556 12.1936H1.85084C0.830781 12.1936 0 11.5114 0 10.6693V1.52422Z"
                fill="currentColor"
            />
            <path
                d="M0 14.9356C0 14.3844 0.830781 13.9355 1.85084 13.9355H12.9556C13.9781 13.9355 14.8064 14.3844 14.8064 14.9356V20.9355C14.8064 21.488 13.9781 21.9355 12.9556 21.9355H1.85084C0.830781 21.9355 0 21.488 0 20.9355V14.9356Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const List = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.25526 10.3628H6.1641C6.76645 10.3628 7.2553 10.9652 7.2553 11.454V16.3628C7.2553 16.9652 6.76645 17.454 6.1641 17.454H1.25526C0.652904 17.454 0.164062 16.8517 0.164062 16.3628V11.454C0.164062 10.8516 0.652904 10.3628 1.25526 10.3628Z"
                fill="currentColor"
            />
            <path
                d="M10.4846 0H23.6617C23.9388 0 24.1638 0.277146 24.1638 0.502141V1.68026C24.1638 1.95741 23.9389 2.1824 23.6617 2.1824H10.4846C10.2074 2.1824 9.98242 1.90526 9.98242 1.68026V0.502141C9.98242 0.224995 10.2074 0 10.4846 0Z"
                fill="currentColor"
            />
            <path
                d="M10.5766 3.81763H19.069C19.3973 3.81763 19.6632 4.1459 19.6632 4.41179V5.40482C19.6632 5.73309 19.3973 5.99898 19.069 5.99898H10.5766C10.2483 5.99898 9.98242 5.6707 9.98242 5.40482V4.41179C9.98242 4.08352 10.2483 3.81763 10.5766 3.81763Z"
                fill="currentColor"
            />
            <path
                d="M10.5551 10.3628H23.5911C23.9071 10.3628 24.1638 10.6788 24.1638 10.9355V11.9715C24.1638 12.2874 23.9072 12.5441 23.5911 12.5441H10.5551C10.2391 12.5441 9.98242 12.2281 9.98242 11.9715V10.9355C9.98242 10.6195 10.2391 10.3628 10.5551 10.3628Z"
                fill="currentColor"
            />
            <path
                d="M10.5009 14.1804H19.1457C19.4321 14.1804 19.6642 14.4668 19.6642 14.6989V15.8443C19.6642 16.1307 19.4321 16.3628 19.1457 16.3628H10.5009C10.2146 16.3628 9.98242 16.0765 9.98242 15.8443V14.6989C9.98242 14.4126 10.2146 14.1804 10.5009 14.1804Z"
                fill="currentColor"
            />
            <path
                d="M1.25526 0H6.1641C6.76645 0 7.2553 0.60236 7.2553 1.0912V6.00003C7.2553 6.60239 6.76645 7.09123 6.1641 7.09123H1.25526C0.652904 7.09123 0.164062 6.48887 0.164062 6.00003V1.0912C0.164062 0.488841 0.652904 0 1.25526 0Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const LargePlus = (props): JSX.Element => {
    return (
        <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.3008 2.96089e-05H13.6964C14.5058 2.96089e-05 15.1676 0.661774 15.1676 1.47119V8.82972H22.5261C23.3355 8.82972 23.9973 9.49147 23.9973 10.3009V13.6965C23.9973 14.5059 23.3356 15.1677 22.5261 15.1677L15.1676 15.169V22.5275C15.1676 23.3369 14.5059 23.9987 13.6964 23.9987L10.3008 24C9.49144 24 8.82966 23.3383 8.82966 22.5288L8.82834 15.169H1.47116C0.661778 15.169 0 14.5072 0 13.6978V10.3022C0 9.49279 0.661744 8.83101 1.47116 8.83101H8.82969L8.82837 1.47248C8.82969 0.663094 9.49143 0 10.3009 0L10.3008 2.96089e-05Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Facebook = (props): JSX.Element => {
    return (
        <svg {...props} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.9375 16L22.9375 16L22.2281 20.625H18.5L18.5 31.8056L18.5 31.8057C26.149 30.6053 32 23.9861 32 16C32 7.16347 24.8366 3.62396e-05 16 3.62396e-05C7.16344 3.62396e-05 0 7.16347 0 16C0 23.9861 5.85097 30.6053 13.5 31.8057L13.5 31.8056L13.5 20.625H9.4375V20.625V16V16H13.5L13.5 12.475C13.5 12.475 13.5 12.475 13.5 12.475C13.5 11.4426 13.6583 10.5293 13.9558 9.74202C14.8138 7.47133 16.8296 6.25 19.5434 6.25C21.294 6.25 23.125 6.5625 23.125 6.5625L23.125 6.56254V10.5H21.1074C19.6168 10.5 18.8954 11.1938 18.6279 12.0744C18.5387 12.368 18.5 12.6823 18.5 12.9987C18.5 12.9987 18.5 12.9987 18.5 12.9987L18.5 16H22.9375Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}

export const Mail = (props): JSX.Element => {
    return (
        <svg {...props} viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.51992 0.719971C1.64991 0.719971 0.919922 1.44995 0.919922 2.31997V17.68C0.919922 18.55 1.64991 19.28 2.51992 19.28H27.4799C28.3499 19.28 29.0799 18.55 29.0799 17.68V2.31997C29.0799 1.44995 28.3499 0.719971 27.4799 0.719971H2.51992ZM4.35992 2.63997H25.6399L15.3398 11.84C15.1998 11.965 14.7998 11.965 14.6598 11.84L4.35992 2.63997ZM2.83992 3.84996L10.03 10.28L2.83992 16.2301V3.84996ZM27.1599 3.84996V16.2301L19.9698 10.28L27.1599 3.84996ZM11.4799 11.57L13.3799 13.27C14.3124 14.1025 15.6874 14.1025 16.6199 13.27L18.5199 11.57L25.5199 17.36H4.47992L11.4799 11.57Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Lifecycle = (props): JSX.Element => {
    return (
        <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4732_120930)">
                <path
                    d="M1 2C1 1.44771 1.44772 1 2 1H4.44444C4.99673 1 5.44444 1.44772 5.44444 2V8.11111H1V2Z"
                    fill="black"
                />
                <path
                    d="M1 8.11133H5.44444V16.0002C5.44444 16.5525 4.99673 17.0002 4.44444 17.0002H2C1.44772 17.0002 1 16.5525 1 16.0002V8.11133Z"
                    fill="black"
                    fillOpacity="0.5"
                />
                <path
                    d="M6.78125 4.6665C6.78125 4.11422 7.22897 3.6665 7.78125 3.6665H10.2257C10.778 3.6665 11.2257 4.11422 11.2257 4.6665V8.11095H6.78125V4.6665Z"
                    fill="black"
                />
                <path
                    d="M6.78125 8.11133H11.2257V12.4447C11.2257 12.9969 10.778 13.4447 10.2257 13.4447H7.78125C7.22897 13.4447 6.78125 12.9969 6.78125 12.4447V8.11133Z"
                    fill="black"
                    fillOpacity="0.5"
                />
                <path
                    d="M12.5547 8.11133H16.9991V10.6669C16.9991 11.2192 16.5514 11.6669 15.9991 11.6669H13.5547C13.0024 11.6669 12.5547 11.2192 12.5547 10.6669V8.11133Z"
                    fill="black"
                    fillOpacity="0.5"
                />
                <path
                    d="M12.5547 8.11133H16.9991V3.778C16.9991 3.22571 16.5514 2.778 15.9991 2.778H13.5547C13.0024 2.778 12.5547 3.22571 12.5547 3.778V8.11133Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_4732_120930">
                    <rect width="17.1429" height="17.1429" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const Trends = (props): JSX.Element => {
    return (
        <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4732_120812)">
                <g clipPath="url(#clip1_4732_120812)">
                    <path
                        d="M1.42969 15.0001L5.97016 10.4596C6.2496 10.1802 6.66739 10.0915 7.03624 10.2334L10.3739 11.5171C10.7881 11.6764 11.2577 11.5437 11.5272 11.1912L15.7154 5.71436"
                        stroke="black"
                        strokeWidth="3"
                        strokeLinecap="round"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_4732_120812">
                    <rect width="17.1429" height="17.1429" fill="white" />
                </clipPath>
                <clipPath id="clip1_4732_120812">
                    <rect width="17.1429" height="17.1429" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const Stickiness = (props): JSX.Element => {
    return (
        <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.5"
                d="M1.65009 11.6785H1.87369C2.01994 13.2676 2.62533 14.7794 3.61603 16.0302C4.60744 17.2811 5.94055 18.2169 7.45363 18.7232C7.54574 18.7534 7.64629 18.7176 7.69762 18.6353C7.74965 18.5538 7.73911 18.4476 7.67301 18.3773L7.50004 18.1945C7.11754 17.7881 7.11684 17.1545 7.49723 16.746L8.29388 15.9044V15.9051C8.34169 15.8537 8.36067 15.782 8.3452 15.7138C8.33044 15.6456 8.28263 15.5894 8.21724 15.5634C6.5677 14.913 5.38998 13.4322 5.12772 11.6786H5.41037C5.66982 11.6793 5.90326 11.5211 5.99958 11.2806C6.09521 11.0395 6.03474 10.7638 5.8463 10.5859L3.9662 8.80774C3.72361 8.5743 3.33971 8.5743 3.09644 8.80703L1.21346 10.5859C1.02502 10.7645 0.964557 11.0394 1.06088 11.2806C1.15721 11.5211 1.38994 11.6793 1.64939 11.6786L1.65009 11.6785Z"
                fill="black"
            />
            <path
                opacity="0.6"
                d="M10.2788 15.0001C10.0384 14.9031 9.76345 14.9643 9.58556 15.1534L7.80525 17.0342C7.57533 17.2789 7.57533 17.66 7.80525 17.9047L9.58556 19.7841C9.76345 19.9725 10.0384 20.033 10.2788 19.9374C10.52 19.8417 10.6782 19.609 10.6782 19.3496V19.1028C12.2715 18.9614 13.7888 18.3574 15.0447 17.366C16.2998 16.3746 17.239 15.0386 17.7461 13.5214C17.7763 13.43 17.7405 13.3295 17.6589 13.2774C17.5774 13.2261 17.4712 13.2359 17.4009 13.302L17.192 13.4989C16.7849 13.8835 16.1493 13.8828 15.7429 13.4982L14.9132 12.7142C14.8619 12.6671 14.7909 12.6474 14.7227 12.6629C14.6552 12.6777 14.5989 12.7255 14.5722 12.7895C13.9112 14.4299 12.4284 15.5949 10.6782 15.8495V15.5879C10.6789 15.3285 10.5207 15.095 10.2789 15.0001L10.2788 15.0001Z"
                fill="black"
            />
            <path
                opacity="0.8"
                d="M12.4966 3.80486C12.8784 4.21196 12.8798 4.84547 12.4994 5.254L11.7365 6.05979C11.6894 6.11041 11.6697 6.18143 11.6845 6.24963C11.7 6.31784 11.7471 6.37409 11.8118 6.40081C12.6218 6.72706 13.3319 7.26142 13.8699 7.9498C14.4078 8.63815 14.7544 9.45589 14.8747 10.3215H14.5857C14.3262 10.3208 14.0928 10.479 13.9964 10.7194C13.9008 10.9606 13.9613 11.2362 14.1497 11.4141L16.0313 13.193C16.2746 13.4237 16.6571 13.4237 16.9003 13.193L18.7826 11.4141V11.4134C18.971 11.2355 19.0315 10.9599 18.9352 10.7194C18.8395 10.479 18.6061 10.3208 18.3467 10.3215H18.128C17.9916 8.70992 17.3827 7.17508 16.3772 5.9086C15.371 4.64298 14.0133 3.70215 12.4748 3.20571C12.3834 3.17829 12.285 3.21556 12.2343 3.29571C12.1837 3.37657 12.1936 3.48063 12.2575 3.55166L12.4966 3.80486Z"
                fill="black"
            />
            <path
                d="M2.31752 8.7437C2.39908 8.79502 2.50456 8.78448 2.57487 8.71838L2.8062 8.49972C3.21401 8.11371 3.85245 8.11582 4.25815 8.50394L5.07026 9.27175H5.06956C5.12089 9.31886 5.1926 9.33854 5.26081 9.32308C5.32901 9.30761 5.38526 9.25979 5.41128 9.19511C5.73119 8.38019 6.26206 7.6644 6.94831 7.12151C7.63456 6.578 8.45301 6.22572 9.31927 6.10127V6.41205V6.41135C9.31927 6.6708 9.47748 6.90354 9.71794 6.99916C9.9591 7.09478 10.2333 7.03432 10.4119 6.84658L12.1922 4.96576C12.4214 4.72107 12.4214 4.34138 12.1922 4.0967L10.4119 2.21588C10.234 2.02744 9.95912 1.96698 9.71794 2.0626C9.47748 2.15823 9.31927 2.39096 9.31927 2.65041V2.84729C7.71263 2.98862 6.18331 3.60034 4.92187 4.6058C3.66117 5.61127 2.72461 6.96614 2.22889 8.50118C2.19936 8.59259 2.23593 8.69314 2.31749 8.74377L2.31752 8.7437Z"
                fill="black"
            />
        </svg>
    )
}

export const Retention = (props): JSX.Element => {
    return (
        <svg {...props} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4732_121042)">
                <g clipPath="url(#clip1_4732_121042)">
                    <path
                        opacity="0.5"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18.9985 10.7825L16.3027 8.08667L13.8678 11.0286L16.5637 13.7245L18.9985 10.7825ZM8.9693 6.14476L11.926 3.69586L9.23012 1L6.27344 3.43486L8.9693 6.14476Z"
                        fill="black"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.8958 12.2029L11.4178 13.9853C10.0699 15.594 7.50497 15.4632 6.02627 13.9853C4.53353 12.4925 4.40276 9.92754 6.02627 8.5797L7.77986 7.13055L5.09876 4.42065L3.31635 5.88456C0.0988495 8.56566 0.359669 13.7104 3.31635 16.6817C6.28707 19.6524 11.4325 19.9132 14.1135 16.6817L15.5774 14.9133L12.8958 12.2029Z"
                        fill="black"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_4732_121042">
                    <rect width="20.5714" height="20.5714" fill="white" />
                </clipPath>
                <clipPath id="clip1_4732_121042">
                    <rect width="18" height="18" fill="white" transform="translate(1 1)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const Search = (props): JSX.Element => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
    )
}

export const Experimentation = (props): JSX.Element => {
    return (
        <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.3607 3.64309C10.3584 3.64461 9.79426 4.58649 9.75326 6.07178V8.50046C9.75326 8.50046 12.6645 12.5731 14.4562 15.0806C14.7197 15.451 14.7554 15.9383 14.5474 16.342C14.3393 16.7466 13.9217 17.0001 13.4676 17.0001H1.24999C0.782279 17.0001 0.352508 16.7375 0.138381 16.3223C-0.0757463 15.9056 -0.0392925 15.404 0.233292 15.023C2.0275 12.5115 4.89449 8.49971 4.89449 8.49971V6.07102C4.85197 4.58573 4.28933 3.64389 4.28705 3.64233H10.3614L10.3607 3.64309ZM9.75326 10.9291H4.8938C4.8938 10.9291 3.04114 13.3981 1.97812 14.815C1.83993 14.9995 1.81791 15.2446 1.92118 15.451C2.02292 15.656 2.23477 15.7865 2.46408 15.7865H12.183C12.4123 15.7865 12.6241 15.6567 12.7259 15.451C12.8292 15.2446 12.8071 14.9995 12.6689 14.815C11.6059 13.3981 9.75326 10.9291 9.75326 10.9291Z"
                fill="black"
            />
            <path
                opacity="0.25"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.85745 4.85742C2.86352 4.85742 3.67975 5.6733 3.67975 6.67894C3.67975 7.68457 2.86352 8.50045 1.85745 8.50045C0.85139 8.50045 0.0351562 7.68457 0.0351562 6.67894C0.0351562 5.6733 0.85139 4.85742 1.85745 4.85742Z"
                fill="black"
            />
            <path
                opacity="0.45"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.46486 1.21436C3.13531 1.21436 3.67973 1.75854 3.67973 2.4287C3.67973 3.09886 3.13531 3.64304 2.46486 3.64304C1.79441 3.64304 1.25 3.09886 1.25 2.4287C1.25 1.75854 1.79441 1.21436 2.46486 1.21436Z"
                fill="black"
            />
            <path
                opacity="0.6"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.1094 0C6.77985 0 7.32426 0.544181 7.32426 1.21434C7.32426 1.8845 6.77985 2.42869 6.1094 2.42869C5.43895 2.42869 4.89453 1.8845 4.89453 1.21434C4.89453 0.544181 5.43895 0 6.1094 0Z"
                fill="black"
            />
        </svg>
    )
}

export const DiagonalArrow = (props): JSX.Element => {
    return (
        <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4684_133779)">
                <path
                    d="M14.8359 3.1829L14.88 10.84C14.88 11.136 14.6444 11.3776 14.3478 11.3776C14.0517 11.3776 13.8155 11.142 13.8155 10.8454L13.7769 4.42256L3.476 14.7235C3.26757 14.9373 2.92744 14.9373 2.719 14.7235C2.50512 14.515 2.50512 14.1803 2.719 13.9665L13.0199 3.66556L6.59706 3.63291C6.30101 3.62747 6.06483 3.39182 6.06483 3.09523C6.06483 2.79917 6.30592 2.56299 6.60251 2.56299L14.2596 2.60707C14.6106 2.60707 14.819 2.84271 14.8353 3.18284L14.8359 3.1829Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_4684_133779">
                    <rect width="17.1429" height="17.1429" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const YouTube = ({ className }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                fill="currentColor"
                d="M20.595 4.461a2.759 2.759 0 0 1 1.945 1.951c.46 1.72.46 5.311.46 5.311s0 3.59-.46 5.312a2.76 2.76 0 0 1-1.945 1.95c-1.715.462-8.595.462-8.595.462s-6.88 0-8.595-.461a2.76 2.76 0 0 1-1.945-1.951C1 15.314 1 11.723 1 11.723s0-3.59.46-5.31A2.76 2.76 0 0 1 3.405 4.46C5.12 4 12 4 12 4s6.88 0 8.595.461ZM15.5 11.723l-5.75 3.26v-6.52l5.75 3.26Z"
                clipRule="evenodd"
            />
        </svg>
    )
}

export const Info = (props: any): JSX.Element => {
    return (
        <svg
            {...props}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            className="fill-current"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="10" cy="10" r="10" fillOpacity="0.2" />
            <path
                fillOpacity="0.75"
                d="M9.04839 15.5074H11.4194V8.53041H9.04839V15.5074ZM9 6.36221H11.5V4.08801H9V6.36221Z"
            />
        </svg>
    )
}

export const DarkMode = (props: any): JSX.Element => {
    return (
        <svg
            className="fill-current"
            width="18"
            height="18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            {...props}
        >
            <path d="M4.534 10a5.465 5.465 0 1010.93 0 5.465 5.465 0 00-10.93 0zm5.519-4.035a4.085 4.085 0 013.538 6.13 4.086 4.086 0 01-3.538 2.043V5.965zm.347-2.554V.96a.46.46 0 10-.918 0V3.41a.46.46 0 00.918 0zm6.274.485a.46.46 0 00-.65-.65l-1.726 1.733a.46.46 0 00.65.65l1.726-1.733zm-.086 6.504h2.452a.46.46 0 100-.918h-2.452a.46.46 0 000 .918zm-2.218 3.897a.458.458 0 000 .65l1.735 1.735h-.001a.462.462 0 00.785-.325.458.458 0 00-.135-.325l-1.734-1.735a.46.46 0 00-.65 0zM9.6 16.588v2.452a.46.46 0 10.918 0v-2.452a.46.46 0 00-.918 0zm-6.282-.484a.461.461 0 00.326.784.455.455 0 00.324-.134l1.734-1.735v.001a.46.46 0 00-.65-.65l-1.734 1.734zM.5 10.052a.46.46 0 00.46.458h2.452a.46.46 0 000-.918H.96a.462.462 0 00-.46.46zm5.13-4.35a.458.458 0 000-.65L3.895 3.318h.001a.46.46 0 00-.65.65L4.98 5.702c.18.178.47.178.65 0z" />
        </svg>
    )
}

export const ExpandDocument = ({ expanded, ...props }: { expanded: boolean | undefined }) => {
    return (
        <svg {...props} width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.175781 0.588402C0.175781 0.263402 0.439061 0.00012207 0.764061 0.00012207C1.08906 0.00012207 1.35234 0.263402 1.35234 0.588402V19.4118C1.35234 19.7368 1.08906 20.0001 0.764061 20.0001C0.439061 20.0001 0.175781 19.7368 0.175781 19.4118V0.588402ZM16.6462 0.588402C16.6462 0.263402 16.9095 0.00012207 17.2345 0.00012207C17.5595 0.00012207 17.8227 0.263402 17.8227 0.588402V19.4118C17.8227 19.7368 17.5595 20.0001 17.2345 20.0001C16.9095 20.0001 16.6462 19.7368 16.6462 19.4118V0.588402ZM4.29298 11.1766C3.96876 11.1766 3.70548 10.9133 3.70548 10.5883C3.70548 10.2633 3.96876 10 4.29298 10H13.7054C14.0296 10 14.2929 10.2633 14.2929 10.5883C14.2929 10.9133 14.0296 11.1766 13.7054 11.1766H4.29298ZM4.29298 14.118C3.96876 14.118 3.70548 13.8539 3.70548 13.5297C3.70548 13.2047 3.96876 12.9414 4.29298 12.9414H13.7054C14.0296 12.9414 14.2929 13.2047 14.2929 13.5297C14.2929 13.8539 14.0296 14.118 13.7054 14.118H4.29298ZM4.29298 17.0586C3.96876 17.0586 3.70548 16.7953 3.70548 16.4703C3.70548 16.1461 3.96876 15.882 4.29298 15.882H13.7054C14.0296 15.882 14.2929 16.1461 14.2929 16.4703C14.2929 16.7953 14.0296 17.0586 13.7054 17.0586H4.29298Z"
                fill="currentColor"
            />
            {expanded ? (
                <>
                    <path
                        d="M9.65232 4.12128L11.6166 2.15695C11.8259 1.94768 12.1652 1.94768 12.3742 2.15695C12.5834 2.36622 12.5834 2.70551 12.3742 2.91447L11.3245 3.96413L14.17 3.96441C14.4658 3.96441 14.709 4.20438 14.709 4.50014C14.709 4.7959 14.4658 5.03587 14.17 5.03587H11.3245L12.3744 6.08553C12.5837 6.2948 12.5837 6.63409 12.3744 6.84305C12.1652 7.05232 11.8259 7.05232 11.6169 6.84305L9.6526 4.87872C9.44333 4.66973 9.44333 4.33051 9.65232 4.12128Z"
                        fill="currentColor"
                    />
                    <path
                        d="M8.55761 4.12128L6.59328 2.15695C6.38401 1.94768 6.04472 1.94768 5.83576 2.15695C5.62649 2.36622 5.62649 2.70551 5.83576 2.91447L6.88543 3.96413L4.14 3.96441C3.84424 3.96441 3.5 4.20438 3.5 4.50014C3.5 4.7959 3.84424 5.03587 4.14 5.03587H6.88543L5.83548 6.08553C5.62621 6.2948 5.62621 6.63409 5.83548 6.84305C6.04474 7.05232 6.38404 7.05232 6.59299 6.84305L8.55732 4.87872C8.76659 4.66973 8.7666 4.33051 8.55761 4.12128Z"
                        fill="currentColor"
                    />
                </>
            ) : (
                <>
                    <path
                        d="M3.65232 4.12128L5.61664 2.15695C5.82591 1.94768 6.16521 1.94768 6.37416 2.15695C6.58343 2.36622 6.58343 2.70551 6.37416 2.91447L5.32449 3.96413L9.17 3.96441C9.46576 3.96441 9.70898 4.20438 9.70898 4.50014C9.70898 4.7959 9.46576 5.03587 9.17 5.03587H5.32449L6.37445 6.08553C6.58372 6.2948 6.58372 6.63409 6.37445 6.84305C6.16518 7.05232 5.82588 7.05232 5.61693 6.84305L3.6526 4.87872C3.44333 4.66973 3.44333 4.33051 3.65232 4.12128Z"
                        fill="currentColor"
                    />
                    <path
                        d="M14.2705 4.12128L12.3062 2.15695C12.0969 1.94768 11.7576 1.94768 11.5487 2.15695C11.3394 2.36622 11.3394 2.70551 11.5487 2.91447L12.5983 3.96413L8.85289 3.96441C8.55713 3.96441 8.21289 4.20438 8.21289 4.50014C8.21289 4.7959 8.55713 5.03587 8.85289 5.03587H12.5983L11.5484 6.08553C11.3391 6.2948 11.3391 6.63409 11.5484 6.84305C11.7576 7.05232 12.0969 7.05232 12.3059 6.84305L14.2702 4.87872C14.4795 4.66973 14.4795 4.33051 14.2705 4.12128Z"
                        fill="currentColor"
                    />
                </>
            )}
        </svg>
    )
}

export const InfoOutlined = (props: any): JSX.Element => {
    return (
        <svg {...props} width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5137 0C5.43881 0 0.513672 4.92514 0.513672 11C0.513672 17.0749 5.43881 22 11.5137 22C17.5885 22 22.5137 17.0749 22.5137 11C22.5137 4.92514 17.5885 0 11.5137 0ZM11.5137 1.49961C6.26711 1.49961 2.01319 5.75353 2.01319 11.0001C2.01319 16.2466 6.26711 20.5006 11.5137 20.5006C16.7602 20.5006 21.0142 16.2466 21.0142 11.0001C21.0142 5.75353 16.7602 1.49961 11.5137 1.49961Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5178 9.00024C11.932 9.00024 12.2681 9.41446 12.2681 9.75049V14.2501C12.2681 14.6644 11.9321 15.0004 11.5178 15.0004C11.1036 15.0004 10.7676 14.5862 10.7676 14.2501V9.75049C10.7676 9.33627 11.1036 9.00024 11.5178 9.00024Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5163 6.99942C12.5163 8.33317 10.5156 8.33317 10.5156 6.99942C10.5156 5.66653 12.5163 5.66653 12.5163 6.99942Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const ThumbUp = (props: any): JSX.Element => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 text-[#6AA84F]"
            {...props}
        >
            <path d="M7.493 18.75c-.425 0-.82-.236-.975-.632A7.48 7.48 0 016 15.375c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75 2.25 2.25 0 012.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23h-.777zM2.331 10.977a11.969 11.969 0 00-.831 4.398 12 12 0 00.52 3.507c.26.85 1.084 1.368 1.973 1.368H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 01-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227z" />
        </svg>
    )
}

export const ThumbDown = (props: any): JSX.Element => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 text-red"
            {...props}
        >
            <path d="M15.73 5.25h1.035A7.465 7.465 0 0118 9.375a7.465 7.465 0 01-1.235 4.125h-.148c-.806 0-1.534.446-2.031 1.08a9.04 9.04 0 01-2.861 2.4c-.723.384-1.35.956-1.653 1.715a4.498 4.498 0 00-.322 1.672V21a.75.75 0 01-.75.75 2.25 2.25 0 01-2.25-2.25c0-1.152.26-2.243.723-3.218C7.74 15.724 7.366 15 6.748 15H3.622c-1.026 0-1.945-.694-2.054-1.715A12.134 12.134 0 011.5 12c0-2.848.992-5.464 2.649-7.521.388-.482.987-.729 1.605-.729H9.77a4.5 4.5 0 011.423.23l3.114 1.04a4.5 4.5 0 001.423.23zM21.669 13.773c.536-1.362.831-2.845.831-4.398 0-1.22-.182-2.398-.52-3.507-.26-.85-1.084-1.368-1.973-1.368H19.1c-.445 0-.72.498-.523.898.591 1.2.924 2.55.924 3.977a8.959 8.959 0 01-1.302 4.666c-.245.403.028.959.5.959h1.053c.832 0 1.612-.453 1.918-1.227z" />
        </svg>
    )
}

export const Group = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" {...props}>
            <path
                fillRule="evenodd"
                d="M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 016.709 7.498.75.75 0 01-.372.568A12.696 12.696 0 0112 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 01-.372-.568 6.787 6.787 0 011.019-4.38z"
                clipRule="evenodd"
            />
            <path d="M5.082 14.254a8.287 8.287 0 00-1.308 5.135 9.687 9.687 0 01-1.764-.44l-.115-.04a.563.563 0 01-.373-.487l-.01-.121a3.75 3.75 0 013.57-4.047zM20.226 19.389a8.287 8.287 0 00-1.308-5.135 3.75 3.75 0 013.57 4.047l-.01.121a.563.563 0 01-.373.486l-.115.04c-.567.2-1.156.349-1.764.441z" />
        </svg>
    )
}

export const Location = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" {...props}>
            <path
                fillRule="evenodd"
                d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                clipRule="evenodd"
            />
        </svg>
    )
}

export const CmdK = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="9" fill="currentColor" {...props}>
            <g>
                <path d="M3.437 3.545v1.717l-.756.006C1.697 5.268.9 6.04.9 7.03a1.78 1.78 0 1 0 3.562 0v-.75h1.7v.75c0 .979.802 1.782 1.78 1.782A1.78 1.78 0 0 0 9.725 7.03c0-.99-.797-1.763-1.781-1.763l-.762-.006V3.545h.762c.984-.006 1.781-.774 1.781-1.764a1.78 1.78 0 1 0-3.562 0v.75h-1.7v-.75C4.462.803 3.66 0 2.682 0A1.78 1.78 0 0 0 .9 1.781c0 .99.797 1.758 1.781 1.764h.756Zm-.732-1.002a.763.763 0 0 1-.774-.762c0-.416.34-.75.75-.75s.756.34.756.774v.738h-.732Zm5.214 0h-.732v-.738c0-.434.346-.774.756-.774.41 0 .75.334.75.75a.767.767 0 0 1-.774.762Zm-3.457 2.73V3.54h1.7v1.734h-1.7Zm-1.757.997h.732v.732a.77.77 0 0 1-.756.78c-.41 0-.75-.34-.75-.757 0-.416.34-.755.774-.755Zm5.214 0c.428 0 .774.34.774.755 0 .416-.34.756-.75.756a.77.77 0 0 1-.756-.779V6.27h.732ZM14.52 8.63V5.716l.924-.948L18.06 8.63h2.04l-3.54-5.04L19.8.23h-2.148L14.52 3.555V.23h-1.632v8.4h1.632Z" />
            </g>
        </svg>
    )
}

export const Ctrl = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="9" fill="currentColor" {...props}>
            <g>
                <path d="M4.515 8.137c1.788 0 3.072-1.036 3.276-2.589v-.037H6.432l-.005.027c-.199.854-.93 1.401-1.912 1.401-1.321 0-2.143-1.1-2.143-2.868v-.01c0-1.762.822-2.863 2.137-2.863.978 0 1.72.607 1.918 1.525l.005.022h1.36v-.043C7.608 1.117 6.271 0 4.508 0 2.313 0 .954 1.552.954 4.066v.01c0 2.504 1.364 4.061 3.56 4.061ZM10.842 7.944h1.386V1.359h2.39V.193h-6.16V1.36h2.384v6.585ZM15.848 7.944h1.386V5.027h1.536l1.52 2.917h1.585l-1.692-3.126c.918-.333 1.46-1.182 1.46-2.208V2.6c0-1.477-.998-2.407-2.663-2.407h-3.132v7.75Zm1.386-3.98V1.316h1.574c.88 0 1.412.505 1.412 1.316v.01c0 .833-.51 1.322-1.385 1.322h-1.601ZM23.105 7.944h4.941V6.778h-3.555V.193h-1.386v7.75Z" />
            </g>
        </svg>
    )
}

export const K = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="9" fill="currentColor" {...props}>
            <path d="M1.496 8.7V6.027l.847-.869L4.741 8.7h1.87L3.366 4.08 6.336 1H4.367L1.496 4.047V1H0v7.7h1.496Z" />
        </svg>
    )
}

export const Clock = (props: any) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
            {...props}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
    )
}

export const Markdown = (props: any) => {
    return (
        <svg
            stroke="currentColor"
            className="w-6 h-6"
            fill="none"
            height="128"
            viewBox="0 0 208 128"
            width="208"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g fill="currentColor">
                <path
                    clipRule="evenodd"
                    d="m15 10c-2.7614 0-5 2.2386-5 5v98c0 2.761 2.2386 5 5 5h178c2.761 0 5-2.239 5-5v-98c0-2.7614-2.239-5-5-5zm-15 5c0-8.28427 6.71573-15 15-15h178c8.284 0 15 6.71573 15 15v98c0 8.284-6.716 15-15 15h-178c-8.28427 0-15-6.716-15-15z"
                    fillRule="evenodd"
                />
                <path d="m30 98v-68h20l20 25 20-25h20v68h-20v-39l-20 25-20-25v39zm125 0-30-33h20v-35h20v35h20z" />
            </g>
        </svg>
    )
}

export const PostHog = (props: any) => {
    return (
        <svg
            {...props}
            className="w-6 h-6"
            width="48"
            height="30"
            viewBox="0 0 48 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.8914 17.2058C10.5229 17.9429 9.47109 17.9429 9.10256 17.2058L8.2212 15.4431C8.08043 15.1616 8.08043 14.8302 8.2212 14.5487L9.10256 12.7859C9.47109 12.0489 10.5229 12.0489 10.8914 12.7859L11.7728 14.5487C11.9135 14.8302 11.9135 15.1616 11.7728 15.4431L10.8914 17.2058Z"
                fill="#1D4AFF"
            ></path>
            <path
                d="M10.8914 27.2026C10.5229 27.9397 9.47109 27.9397 9.10256 27.2026L8.2212 25.4399C8.08043 25.1584 8.08043 24.827 8.2212 24.5455L9.10256 22.7828C9.47109 22.0457 10.5229 22.0457 10.8914 22.7828L11.7728 24.5455C11.9135 24.827 11.9135 25.1584 11.7728 25.4399L10.8914 27.2026Z"
                fill="#1D4AFF"
            ></path>
            <path
                d="M0 23.4082C0 22.5173 1.07714 22.0711 1.70711 22.7011L6.29049 27.2845C6.92046 27.9145 6.47429 28.9916 5.58339 28.9916H0.999999C0.447715 28.9916 0 28.5439 0 27.9916V23.4082ZM0 18.5804C0 18.8456 0.105357 19.1 0.292893 19.2875L9.70411 28.6987C9.89164 28.8862 10.146 28.9916 10.4112 28.9916H15.5804C16.4713 28.9916 16.9175 27.9145 16.2875 27.2845L1.70711 12.7041C1.07714 12.0741 0 12.5203 0 13.4112V18.5804ZM0 8.58339C0 8.8486 0.105357 9.10296 0.292893 9.29049L19.7011 28.6987C19.8886 28.8862 20.143 28.9916 20.4082 28.9916H25.5774C26.4683 28.9916 26.9145 27.9145 26.2845 27.2845L1.70711 2.70711C1.07715 2.07715 0 2.52331 0 3.41421V8.58339ZM9.997 8.58339C9.997 8.8486 10.1024 9.10296 10.2899 9.29049L28.2839 27.2845C28.9139 27.9145 29.991 27.4683 29.991 26.5774V21.4082C29.991 21.143 29.8856 20.8886 29.6981 20.7011L11.7041 2.7071C11.0741 2.07714 9.997 2.52331 9.997 3.41421V8.58339ZM21.7011 2.70711C21.0711 2.07714 19.994 2.52331 19.994 3.41421V8.58339C19.994 8.8486 20.0994 9.10296 20.2869 9.29049L28.2839 17.2875C28.9139 17.9175 29.991 17.4713 29.991 16.5804V11.4112C29.991 11.146 29.8856 10.8916 29.6981 10.7041L21.7011 2.70711Z"
                fill="#F9BD2B"
            ></path>
            <path
                className="fill-primary dark:fill-white"
                d="M42.5248 23.5308L33.1121 14.118C32.4821 13.488 31.405 13.9342 31.405 14.8251V27.9915C31.405 28.5438 31.8527 28.9915 32.405 28.9915H46.9856C47.5379 28.9915 47.9856 28.5438 47.9856 27.9915V26.7925C47.9856 26.2402 47.536 25.7992 46.9883 25.7279C45.3076 25.509 43.7355 24.7414 42.5248 23.5308ZM36.2035 25.7925C35.3206 25.7925 34.604 25.0759 34.604 24.193C34.604 23.31 35.3206 22.5934 36.2035 22.5934C37.0865 22.5934 37.8031 23.31 37.8031 24.193C37.8031 25.0759 37.0865 25.7925 36.2035 25.7925Z"
                fill="black"
            ></path>
            <path
                d="M0 27.9915C0 28.5438 0.447715 28.9915 1 28.9915H5.58339C6.47429 28.9915 6.92046 27.9144 6.2905 27.2844L1.70711 22.701C1.07714 22.071 0 22.5172 0 23.4081V27.9915Z"
                fill="#1D4AFF"
            ></path>
            <path
                d="M9.997 10.997L1.70711 2.70711C1.07714 2.07714 0 2.52331 0 3.41421V8.58339C0 8.8486 0.105357 9.10296 0.292893 9.29049L9.997 18.9946V10.997Z"
                fill="#1D4AFF"
            ></path>
            <path
                d="M1.70711 12.7042C1.07714 12.0742 0 12.5204 0 13.4113V18.5805C0 18.8457 0.105357 19.1 0.292893 19.2876L9.997 28.9917V20.9941L1.70711 12.7042Z"
                fill="#1D4AFF"
            ></path>
            <path
                d="M19.994 11.4112C19.994 11.146 19.8887 10.8916 19.7011 10.7041L11.7041 2.70711C11.0742 2.07714 9.99701 2.52331 9.99701 3.41421V8.58339C9.99701 8.8486 10.1024 9.10296 10.2899 9.29049L19.994 18.9946V11.4112Z"
                fill="#F54E00"
            ></path>
            <path
                d="M9.99701 28.9915H15.5804C16.4713 28.9915 16.9175 27.9144 16.2875 27.2844L9.99701 20.9939V28.9915Z"
                fill="#F54E00"
            ></path>
            <path
                d="M9.99701 10.9971V18.5805C9.99701 18.8457 10.1024 19.1 10.2899 19.2876L19.994 28.9917V21.4083C19.994 21.1431 19.8887 20.8887 19.7011 20.7012L9.99701 10.9971Z"
                fill="#F54E00"
            ></path>
            <path
                className="fill-primary dark:fill-white"
                d="M59.6496 25H63.7576V18.188H67.1896C70.9596 18.188 73.3776 15.9521 73.3776 12.494C73.3776 9.03605 70.9596 6.80005 67.1896 6.80005H59.6496V25ZM63.7576 14.678V10.3101H66.7736C68.3336 10.3101 69.2696 11.142 69.2696 12.494C69.2696 13.8461 68.3336 14.678 66.7736 14.678H63.7576Z"
                fill="black"
            ></path>
            <path
                className="fill-primary dark:fill-white"
                d="M80.8095 25.208C84.8135 25.208 87.7255 22.348 87.7255 18.448C87.7255 14.548 84.8135 11.688 80.8095 11.688C76.7535 11.688 73.8935 14.548 73.8935 18.448C73.8935 22.348 76.7535 25.208 80.8095 25.208ZM77.6895 18.448C77.6895 16.368 78.9375 14.938 80.8095 14.938C82.6555 14.938 83.9035 16.368 83.9035 18.448C83.9035 20.528 82.6555 21.958 80.8095 21.958C78.9375 21.958 77.6895 20.528 77.6895 18.448Z"
                fill="black"
            ></path>
            <path
                className="fill-primary dark:fill-white"
                d="M94.2995 25.208C97.3675 25.208 99.4475 23.284 99.4475 21.022C99.4475 15.718 92.4015 17.434 92.4015 15.354C92.4015 14.7821 92.9995 14.4181 93.8575 14.4181C94.7415 14.4181 95.8075 14.964 96.1455 16.16L99.2135 14.886C98.6155 12.988 96.4055 11.688 93.7275 11.688C90.8415 11.688 89.0475 13.404 89.0475 15.458C89.0475 20.424 95.9895 19.046 95.9895 21.1C95.9895 21.828 95.3135 22.3221 94.2995 22.3221C92.8435 22.3221 91.8295 21.3081 91.5175 20.0861L88.4495 21.282C89.1255 23.258 91.1015 25.208 94.2995 25.208Z"
                fill="black"
            ></path>
            <path
                className="fill-primary dark:fill-white"
                d="M109.33 24.8701L109.07 21.5681C108.628 21.8021 108.056 21.88 107.588 21.88C106.652 21.88 106.028 21.2041 106.028 20.034V15.068H109.2V11.896H106.028V8.10005H102.206V11.896H100.126V15.068H102.206V20.528C102.206 23.7001 104.364 25.208 107.198 25.208C107.978 25.208 108.706 25.0781 109.33 24.8701Z"
                fill="black"
            ></path>
            <path
                className="fill-primary dark:fill-white"
                d="M122.656 6.80005V13.872H115.428V6.80005H111.32V25H115.428V17.382H122.656V25H126.79V6.80005H122.656Z"
                fill="black"
            ></path>
            <path
                className="fill-primary dark:fill-white"
                d="M135.908 25.208C139.912 25.208 142.824 22.348 142.824 18.448C142.824 14.548 139.912 11.688 135.908 11.688C131.852 11.688 128.992 14.548 128.992 18.448C128.992 22.348 131.852 25.208 135.908 25.208ZM132.788 18.448C132.788 16.368 134.036 14.938 135.908 14.938C137.754 14.938 139.002 16.368 139.002 18.448C139.002 20.528 137.754 21.958 135.908 21.958C134.036 21.958 132.788 20.528 132.788 18.448Z"
                fill="black"
            ></path>
            <path
                className="fill-primary dark:fill-white"
                d="M150.201 24.584C151.631 24.584 152.905 24.09 153.581 23.232V24.48C153.581 25.936 152.411 26.9501 150.617 26.9501C149.343 26.9501 148.225 26.326 148.043 25.26L144.559 25.806C145.027 28.276 147.549 29.9401 150.617 29.9401C154.647 29.9401 157.325 27.574 157.325 24.064V11.896H153.555V13.014C152.853 12.208 151.657 11.688 150.123 11.688C146.483 11.688 144.195 14.184 144.195 18.136C144.195 22.088 146.483 24.584 150.201 24.584ZM147.913 18.136C147.913 16.186 149.057 14.938 150.825 14.938C152.619 14.938 153.763 16.186 153.763 18.136C153.763 20.086 152.619 21.334 150.825 21.334C149.057 21.334 147.913 20.086 147.913 18.136Z"
                fill="black"
            ></path>
        </svg>
    )
}

export const ClosedIssue = (props: any) => {
    return (
        <svg {...props} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6103_20817)">
                <path
                    d="M11.3013 7.00031C11.4338 6.85813 11.5059 6.67008 11.5025 6.47578C11.4991 6.28148 11.4204 6.0961 11.283 5.95868C11.1455 5.82127 10.9602 5.74256 10.7659 5.73913C10.5716 5.7357 10.3835 5.80783 10.2413 5.94031L7.27133 8.91031L5.80133 7.44031C5.65916 7.30783 5.47111 7.2357 5.27681 7.23913C5.08251 7.24256 4.89712 7.32127 4.75971 7.45868C4.6223 7.5961 4.54358 7.78148 4.54016 7.97578C4.53673 8.17008 4.60885 8.35813 4.74133 8.50031L6.74133 10.5003C6.88196 10.6408 7.07258 10.7196 7.27133 10.7196C7.47008 10.7196 7.66071 10.6408 7.80133 10.5003L11.3013 7.00031Z"
                    fill="#A371F7"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0215 8.22034C16.0215 10.3421 15.1786 12.3769 13.6783 13.8772C12.178 15.3775 10.1432 16.2203 8.02148 16.2203C5.89975 16.2203 3.86492 15.3775 2.36463 13.8772C0.864339 12.3769 0.0214844 10.3421 0.0214844 8.22034C0.0214844 6.09861 0.864339 4.06377 2.36463 2.56348C3.86492 1.06319 5.89975 0.220337 8.02148 0.220337C10.1432 0.220337 12.178 1.06319 13.6783 2.56348C15.1786 4.06377 16.0215 6.09861 16.0215 8.22034ZM14.5215 8.22034C14.5215 9.94424 13.8367 11.5975 12.6177 12.8165C11.3987 14.0355 9.74539 14.7203 8.02148 14.7203C6.29758 14.7203 4.64428 14.0355 3.42529 12.8165C2.2063 11.5975 1.52148 9.94424 1.52148 8.22034C1.52148 6.49643 2.2063 4.84313 3.42529 3.62414C4.64428 2.40516 6.29758 1.72034 8.02148 1.72034C9.74539 1.72034 11.3987 2.40516 12.6177 3.62414C13.8367 4.84313 14.5215 6.49643 14.5215 8.22034Z"
                    fill="#A371F7"
                />
            </g>
            <defs>
                <clipPath id="clip0_6103_20817">
                    <rect width="16" height="16" fill="white" transform="translate(0.0214844 0.220337)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const OpenIssue = (props: any) => {
    return (
        <svg {...props} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6103_31895)">
                <path
                    d="M8.02148 9.72034C8.41931 9.72034 8.80084 9.5623 9.08214 9.281C9.36345 8.99969 9.52148 8.61816 9.52148 8.22034C9.52148 7.82251 9.36345 7.44098 9.08214 7.15968C8.80084 6.87837 8.41931 6.72034 8.02148 6.72034C7.62366 6.72034 7.24213 6.87837 6.96082 7.15968C6.67952 7.44098 6.52148 7.82251 6.52148 8.22034C6.52148 8.61816 6.67952 8.99969 6.96082 9.281C7.24213 9.5623 7.62366 9.72034 8.02148 9.72034Z"
                    fill="#3FB950"
                    fillOpacity="0.9"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.02148 0.220337C5.89975 0.220337 3.86492 1.06319 2.36463 2.56348C0.864339 4.06377 0.0214844 6.09861 0.0214844 8.22034C0.0214844 10.3421 0.864339 12.3769 2.36463 13.8772C3.86492 15.3775 5.89975 16.2203 8.02148 16.2203C10.1432 16.2203 12.178 15.3775 13.6783 13.8772C15.1786 12.3769 16.0215 10.3421 16.0215 8.22034C16.0215 6.09861 15.1786 4.06377 13.6783 2.56348C12.178 1.06319 10.1432 0.220337 8.02148 0.220337V0.220337ZM1.52148 8.22034C1.52148 6.49643 2.2063 4.84313 3.42529 3.62414C4.64428 2.40516 6.29758 1.72034 8.02148 1.72034C9.74539 1.72034 11.3987 2.40516 12.6177 3.62414C13.8367 4.84313 14.5215 6.49643 14.5215 8.22034C14.5215 9.94424 13.8367 11.5975 12.6177 12.8165C11.3987 14.0355 9.74539 14.7203 8.02148 14.7203C6.29758 14.7203 4.64428 14.0355 3.42529 12.8165C2.2063 11.5975 1.52148 9.94424 1.52148 8.22034Z"
                    fill="#3FB950"
                    fillOpacity="0.9"
                />
            </g>
            <defs>
                <clipPath id="clip0_6103_31895">
                    <rect width="16" height="16" fill="white" transform="translate(0.0214844 0.220337)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const LinkIcon = (props: any) => {
    return (
        <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.5722 10.4647L15.8532 8.18299C17.5175 6.51939 17.5175 3.81169 15.8532 2.14813C14.1896 0.483828 11.4819 0.483828 9.81759 2.14813L6.52557 5.44015C4.86127 7.10374 4.86127 9.81145 6.52557 11.475C6.77096 11.7211 7.04026 11.9292 7.32502 12.1022L9.08706 10.3395C8.75166 10.2593 8.43315 10.0899 8.1716 9.8283C7.41504 9.07174 7.41504 7.84128 8.1716 7.08474L11.4636 3.79271C12.2202 3.03616 13.4506 3.03616 14.2072 3.79271C14.9637 4.54927 14.9637 5.77974 14.2072 6.53627L13.2404 7.50378C13.639 8.44244 13.7487 9.4746 13.5723 10.4646L13.5722 10.4647Z"
                fill="currentColor"
            />
            <path
                d="M4.42957 7.53536L2.14861 9.81632C0.484316 11.4799 0.484316 14.1876 2.14861 15.8519C3.81221 17.5162 6.51991 17.5162 8.18419 15.8519L11.4762 12.5599C13.1405 10.8963 13.1398 8.18858 11.4762 6.52502C11.2308 6.27892 10.9615 6.07081 10.6775 5.89783L8.91543 7.66057C9.25082 7.74072 9.56933 7.91017 9.83089 8.17173C10.5874 8.92829 10.5874 10.1588 9.83089 10.9153L6.53887 14.2073C5.78231 14.9639 4.55185 14.9639 3.79531 14.2073C3.03875 13.4508 3.03875 12.2203 3.79531 11.4638L4.76281 10.497C4.36272 9.55757 4.25305 8.52541 4.42952 7.53541L4.42957 7.53536Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const Bookmark = (props: any) => {
    return (
        <svg {...props} width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.88692 0.12504H2.0625C1.13086 0.12504 0.375 0.880896 0.375 1.81254V15.3125C0.375703 15.52 0.490312 15.7098 0.673116 15.8075C0.852412 15.8996 1.06687 15.8884 1.23562 15.7794L6.00004 12.6125L10.7531 15.7794C10.9254 15.8926 11.1462 15.9032 11.3283 15.8054C11.5097 15.7084 11.6236 15.5185 11.625 15.3125V1.86312C11.625 0.903356 10.8467 0.12504 9.88692 0.12504ZM10.5 14.2606L6.30946 11.4481C6.12172 11.3244 5.87845 11.3244 5.69071 11.4481L1.50013 14.2606V1.81254C1.50013 1.50175 1.75184 1.25004 2.06263 1.25004H9.88147C10.0453 1.24863 10.2028 1.31262 10.3188 1.42793C10.4348 1.54254 10.5002 1.69933 10.5002 1.86317L10.5 14.2606Z"
                fill="currentColor"
            />
        </svg>
    )
}

export const TableOfContents = (props: any) => {
    return (
        <svg {...props} width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.13295 1.06697C2.13295 2.48894 0 2.48894 0 1.06697C0 -0.355005 2.13295 -0.355005 2.13295 1.06697Z"
                fill="currentColor"
            />
            <path d="M4.26562 0H15.9984V2.13294H4.26562V0Z" fill="currentColor" />
            <path
                d="M2.13295 5.33383C2.13295 6.7558 0 6.7558 0 5.33383C0 3.91086 2.13295 3.91086 2.13295 5.33383Z"
                fill="currentColor"
            />
            <path d="M4.26562 4.26685H15.9984V6.39979H4.26562V4.26685Z" fill="currentColor" />
            <path
                d="M2.13295 9.59968C2.13295 11.0227 0 11.0227 0 9.59968C0 8.17771 2.13295 8.17771 2.13295 9.59968Z"
                fill="currentColor"
            />
            <path d="M4.26562 8.53394H15.9984V10.6669H4.26562V8.53394Z" fill="currentColor" />
            <path
                d="M2.13295 13.8668C2.13295 15.2887 0 15.2887 0 13.8668C0 12.4448 2.13295 12.4448 2.13295 13.8668Z"
                fill="currentColor"
            />
            <path d="M4.26562 12.7996H15.9984V14.9325H4.26562V12.7996Z" fill="currentColor" />
        </svg>
    )
}

export const Heart = (props: any) => {
    return (
        <svg
            {...props}
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill={props?.active ? 'currentColor' : 'none'}
            xmlns="http://www.w3.org/2000/svg"
            className={props.className ?? ''}
        >
            <path
                d="M12 5.85916C18.3331 -0.580419 29.1898 11.3788 12 21.0372C-5.18982 11.3789 5.66687 -0.58042 12 5.85916Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const YC = ({ className = '' }: { className?: string }): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 212 44" fill="#FB651E" className={className}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0h43.862v44H0V0Zm12.867 10.707 7.603 14.226v9.24h2.924V25.08l7.603-14.373H27.78l-4.386 8.946c-.293.44-.585.88-.731 1.32-.084.338-.217.579-.342.806-.093.167-.181.328-.243.514-.073-.073-.11-.183-.146-.293-.037-.11-.073-.22-.146-.293-.074-.147-.11-.257-.147-.367a2.529 2.529 0 0 0-.146-.367v-.146l-.146-.147a2.881 2.881 0 0 1-.12-.28c-.048-.125-.082-.216-.172-.307-.147-.146-.293-.293-.293-.44l-4.386-8.946h-3.51Z"
            fill="#FB651E"
        />
        <path
            d="M63.893 8.507c2.193 0 4.094.586 5.556 1.76l-1.462 1.76c-1.316-.88-2.632-1.467-4.24-1.467-2.486 0-4.386 1.32-5.41 3.813-.585 1.467-.877 3.374-.877 5.867 0 1.907.292 3.52.73 4.693 1.17 2.787 3.071 4.107 5.995 4.107 1.609 0 3.07-.44 4.387-1.467l1.462 1.907c-1.901 1.173-3.948 1.76-6.141 1.76-2.632 0-4.825-1.027-6.58-3.227-1.754-2.053-2.485-4.84-2.485-8.213 0-3.373.877-6.013 2.632-8.213 1.608-1.907 3.801-3.08 6.433-3.08ZM72.226 23.027c0-2.64.585-4.694 1.9-6.16 1.317-1.467 2.925-2.347 4.972-2.347 2.34 0 4.24.88 5.556 2.787 1.023 1.466 1.462 3.52 1.462 6.013 0 2.933-.877 5.28-2.486 6.747-1.17 1.026-2.631 1.613-4.386 1.613-2.193 0-3.801-.733-5.117-2.347-1.316-1.466-1.9-3.666-1.9-6.306Zm10.235-4.254c-.731-1.32-1.755-2.053-3.363-2.053s-2.632.587-3.363 1.76c-.585.88-.731 2.347-.731 4.253 0 2.494.292 4.254 1.023 5.28.731 1.027 1.755 1.614 3.217 1.614 1.755 0 2.924-.88 3.509-2.494.292-.88.439-2.053.439-3.52.146-2.2-.147-3.813-.731-4.84ZM90.795 19.067c0-1.614-.146-2.934-.585-3.96l2.486-.587c.438.733.584 1.613.584 2.347v.146c.585-.586 1.17-1.173 2.047-1.613 1.024-.587 1.9-.88 2.778-.88 1.316 0 2.486.587 3.217 1.613.146.294.438.734.585 1.027 1.754-1.76 3.362-2.64 5.117-2.64 1.169 0 2.193.44 2.924 1.173.731.88 1.17 1.907 1.17 3.08v12.174h-2.632V18.92c0-1.613-.731-2.347-2.047-2.347-.731 0-1.608.294-2.339.88-.293.294-.878.734-1.609 1.32l-.292.294v11.88h-2.778v-11.44c0-1.027-.146-1.76-.439-2.054-.438-.44-.877-.586-1.608-.586-1.17 0-2.485.733-4.094 2.2v12.026h-2.485V19.067ZM115.65 7.92l2.632-.587c.293 1.174.439 2.494.439 4.107v5.427c1.462-1.467 3.07-2.2 4.678-2.2 1.901 0 3.509.733 4.533 2.2 1.169 1.466 1.754 3.52 1.754 6.013 0 2.64-.585 4.693-1.754 6.307-1.17 1.613-2.778 2.346-4.679 2.346a5.15 5.15 0 0 1-2.485-.586c-.878-.44-1.462-.88-1.901-1.467-.146.733-.292 1.32-.439 1.76h-2.485c.292-.733.438-2.053.438-4.107v-15.4c-.146-1.76-.292-3.08-.731-3.813Zm4.24 9.973a4.457 4.457 0 0 0-1.169 1.174v8.36c1.023 1.32 2.339 1.906 3.947 1.906 1.316 0 2.34-.44 2.924-1.466.732-1.174 1.17-2.787 1.17-5.134 0-2.053-.292-3.52-1.023-4.4-.585-.88-1.609-1.32-3.071-1.32-.877-.146-1.9.147-2.778.88ZM133.487 9.973c0-.586.146-1.026.585-1.466.438-.44.877-.587 1.462-.587s1.023.147 1.462.587c.438.44.585.88.585 1.466 0 .587-.147 1.027-.585 1.467-.439.44-.877.587-1.462.587s-1.024-.147-1.462-.587c-.439-.44-.585-.88-.585-1.467Zm.585 21.12V14.96l2.631-.44v16.573h-2.631ZM142.406 19.067c0-1.174 0-1.907-.146-2.2 0-.44-.292-.88-.585-1.614l2.486-.733c.438.88.585 1.613.585 2.493 1.608-1.613 3.362-2.493 5.117-2.493.877 0 1.608.147 2.339.587.731.44 1.316 1.026 1.608 1.76.293.586.439 1.173.439 1.906v12.32h-2.485v-11c0-1.32-.147-2.2-.585-2.64a2.42 2.42 0 0 0-1.755-.733c-.585 0-1.462.293-2.339.733a8.525 8.525 0 0 0-2.193 1.614v12.026h-2.486V19.067ZM160.096 18.48l-1.316-1.76c2.193-1.467 4.387-2.2 6.726-2.2 2.339 0 3.801.88 4.532 2.493.293.587.293 1.467.293 2.787v.88l-.147 5.28v.733c0 .88 0 1.467.147 1.907.146.587.585 1.027 1.169 1.32l-1.316 1.76c-1.169-.44-1.9-1.173-2.193-2.347-1.462 1.467-3.07 2.2-4.678 2.2-1.609 0-2.924-.44-3.948-1.32-.877-.733-1.316-1.906-1.316-3.373 0-1.907.731-3.227 2.193-4.253 1.462-1.027 3.656-1.467 6.287-1.467h1.17v-1.173c0-1.32-.146-2.2-.585-2.494-.585-.586-1.17-.88-2.193-.88-.877 0-1.901.294-3.07.734-.439.293-1.024.733-1.755 1.173Zm7.749 8.653.146-4.253h-1.315c-2.34 0-3.802.44-4.679 1.32-.585.587-.877 1.467-.877 2.64 0 1.907.877 2.933 2.778 2.933 1.754-.146 3.07-1.026 3.947-2.64ZM178.665 14.96h4.094l-.731 2.053h-3.363v10.414c0 .88.147 1.466.439 1.906.292.294.877.587 1.608.587.585 0 1.17-.147 1.609-.293l.292 1.613c-.877.44-1.754.587-2.778.587-2.485 0-3.655-1.174-3.655-3.667V17.013h-2.193V14.96h2.047v-.293c0-.294.146-1.467.292-3.374v-.44l2.632-.586c-.293 1.76-.293 3.373-.293 4.693ZM185.392 23.027c0-2.64.584-4.694 1.9-6.16 1.17-1.467 2.924-2.347 4.971-2.347 2.34 0 4.24.88 5.556 2.787 1.024 1.466 1.462 3.52 1.462 6.013 0 2.933-.877 5.28-2.485 6.747-1.17 1.026-2.632 1.613-4.386 1.613-2.194 0-3.802-.733-5.118-2.347-1.169-1.466-1.9-3.666-1.9-6.306Zm10.38-4.254c-.731-1.32-1.754-2.053-3.362-2.053-1.609 0-2.632.587-3.363 1.76-.585.88-.731 2.347-.731 4.253 0 2.494.292 4.254 1.023 5.28.731 1.027 1.755 1.614 3.217 1.614 1.754 0 2.924-.88 3.509-2.494.292-.88.438-2.053.438-3.52 0-2.2-.292-3.813-.731-4.84ZM204.104 18.773c0-1.466-.146-2.64-.584-3.52l2.485-.733c.439.88.585 1.613.585 2.493v.294c1.316-1.76 2.778-2.64 4.532-2.64.293 0 .585 0 .878.146l-1.024 2.787c-.292-.147-.585-.147-.731-.147-.585 0-1.316.147-1.901.587-.584.44-1.169.88-1.462 1.467a5.493 5.493 0 0 0-.292 1.76v10.12h-2.486V18.773Z"
            fill="#FB651E"
        />
    </svg>
)

export const PaperPlaneArrow = ({ className = '' }: { className: string }): JSX.Element => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.5512 21.7065C13.6891 22.1776 14.3525 22.1886 14.506 21.7223L20.1934 4.44133C20.3217 4.05162 19.9519 3.68182 19.5622 3.81008L2.28119 9.49749C1.81488 9.65096 1.8259 10.3144 2.29705 10.4523L10.7405 12.9236C10.9041 12.9714 11.0321 13.0994 11.0799 13.263L13.5512 21.7065Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
